(function() {
  "use strict";
  try {
    if (typeof document != "undefined") {
      var elementStyle = document.createElement("style");
      elementStyle.appendChild(document.createTextNode('.channelitem {\n  position: relative;\n  display: flex;\n  width: 100%;\n  gap: 16px;\n  margin-bottom: 8px;\n}\n.channelitem-avatar {\n  overflow: hidden;\n  width: 60px;\n  height: 60px;\n  flex-shrink: 0;\n}\n.channelitem-avatar > i {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--primary);\n}\n.channelitem-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.channelitem-main {\n  font-size: 14px;\n  color: #fff;\n  padding-bottom: 4px;\n  width: calc(100% - 200px);\n}\n.channelitem-bottom {\n  color: #ccc;\n  font-size: 12px;\n  margin-top: 5px;\n}\n.channelitem-bottom > div {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.channelitem-right {\n  margin-left: auto;\n}\n.channelitem-right .badge {\n  flex-shrink: 0;\n  align-self: flex-end;\n  font-size: 12px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #9c94ff;\n  color: #171821;\n  margin-top: 3px;\n  margin-left: auto;\n}\n.channelitem::after {\n  content: "";\n  width: calc(100% - 76px);\n  height: 1px;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  background: #334663;\n}\n.channelitem-extra {\n  height: 100%;\n}\n\n.channel-swipe {\n  position: relative;\n  overflow: hidden;\n  cursor: grab;\n}\n.channel-swipe-wrapper {\n  height: inherit;\n  transition-property: transform, -webkit-transform;\n}\n.channel-swipe-left, .channel-swipe-right {\n  position: absolute;\n  top: 0;\n  height: 100%;\n}\n.channel-swipe-right {\n  right: 0;\n  transform: translate3d(101%, 0, 0);\n}\n.channel-swipe .block-btn {\n  background: #eb445a;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 50px;\n}\n.channel-swipe .block-btn span {\n  color: #000;\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.tool-bar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  gap: 0.5rem;\n}\n.tool-bar .edit {\n  cursor: pointer;\n}\n.tool-bar .edit svg {\n  display: block;\n  fill: #fff;\n  stroke: #fff;\n}\n.tool-bar .remove {\n  cursor: pointer;\n}\n.tool-bar .remove svg {\n  display: block;\n  stroke: #fff;\n}\n.tool-bar .remove.last {\n  display: none;\n}.chatmessage {\n  box-sizing: border-box;\n  position: relative;\n}\n.chatmessage-content {\n  align-items: flex-end;\n  display: flex;\n  margin-bottom: 30px;\n  padding: 0 16px;\n}\n.chatmessage-theMessage {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n}\n.chatmessage-box {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n}\n.chatmessage-box.self {\n  flex-direction: row-reverse;\n}\n.chatmessage-box .avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 12px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n.chatmessage-msgMain {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  position: relative;\n  width: fit-content;\n  max-width: 80%;\n}\n.chatmessage-chat_content {\n  display: flex;\n  gap: 6px;\n  box-sizing: border-box;\n}\n.chatmessage-chat_content.self {\n  flex-direction: row-reverse;\n}\n.chatmessage-chat_content .default-avatar {\n  background: var(--primary);\n  border-radius: 12px;\n  width: 32px;\n  height: 32px;\n}\n.chatmessage-emoji {\n  left: 0;\n  position: absolute;\n  top: -70px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.chatmessage-emoji.self {\n  flex-direction: row-reverse;\n}\n.chatmessage-picker {\n  bottom: -162px;\n  position: absolute;\n  inset-inline-end: auto;\n  inset-inline-start: auto;\n  z-index: 3;\n}\n.chatmessage-comment {\n  bottom: -68px;\n  right: auto;\n  position: absolute;\n  z-index: 2;\n}\n.chatmessage-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding-top: 8px;\n}\n.chatmessage-toolbar > svg {\n  width: 16px;\n  height: 16px;\n}\n.chatmessage-time {\n  align-items: center;\n  display: flex;\n  margin-left: 4px;\n  line-height: 2;\n  width: 100%;\n  font-size: 12px;\n  color: #72767e;\n}\n.chatmessage .bot_toolbar {\n  display: flex;\n  margin-top: 10px;\n  margin-left: 60px;\n}\n.chatmessage .bot_toolbar .downloadBtn {\n  margin-right: 8px;\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n}\n.chatmessage .bot_toolbar .downloadBtn svg {\n  fill: #1F2022;\n}\n.chatmessage .bot_toolbar .downloadBtn svg path {\n  stroke: #D9DFE8;\n}\n.chatmessage .bot_toolbar .copyBtn {\n  margin-right: 8px;\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n}\n.chatmessage .bot_toolbar .copyBtn svg {\n  fill: #1F2022;\n}\n.chatmessage .bot_toolbar .copyBtn svg .icon-react {\n  stroke: #D9DFE8;\n}\n.chatmessage .bot_toolbar .copyBtn .copySuccess {\n  width: 39px;\n  height: 39px;\n  border-radius: 50%;\n  background: #1F2022;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #1F2022;\n}\n.chatmessage .bot_toolbar .copyBtn .copySuccess svg {\n  stroke: white;\n}.emojiPicker-list {\n  padding: 4px 8px;\n  display: flex;\n  border-radius: 30px;\n  background-color: #000000;\n  gap: 2px;\n}\n.emojiPicker-list > div {\n  text-align: center;\n  line-height: 40px;\n  width: 40px;\n  height: 40px;\n  font-size: 16px;\n  border-radius: 50%;\n}\n.emojiPicker-list > div[class*=active] {\n  background-color: #003999;\n}.emojiComment {\n  display: flex;\n  gap: 2px;\n}\n.emojiComment > div {\n  background-color: #585155;\n  border-radius: 6px;\n  display: flex;\n  font-size: 14px;\n  height: 20px;\n  line-height: 20px;\n  padding: 0 4px;\n  text-align: center;\n}\n.emojiComment > div span {\n  color: #fff;\n}.chatSend {\n  align-items: center;\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n  padding: 20px 0;\n  position: relative;\n  font-size: 0;\n}\n.chatSend-content {\n  align-items: center;\n  background-color: #2d323e;\n  border-radius: 25px;\n  display: flex;\n  flex: 1 1;\n  gap: 8px;\n  padding: 12px;\n}\n.chatSend-content input {\n  background-color: transparent;\n  border: none;\n  flex: 1 1;\n  font-size: 16px;\n  outline: none;\n  color: #fff;\n}\n.chatSend-content input::placeholder {\n  color: #ccc;\n}\n.chatSend .sendBtn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background-color: var(--primary);\n  cursor: pointer;\n}\n.chatSend .sendBtn.disabled {\n  cursor: not-allowed;\n  filter: grayscale(100%);\n}.personal-chat {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background: #101A25;\n  position: relative;\n  overflow: hidden;\n}\n.personal-chat__header {\n  height: 56px;\n  padding: 12px;\n  background-color: #000;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.personal-chat__content {\n  flex: 1 1;\n  display: flex;\n  flex-direction: column;\n  padding: 0 12px;\n  height: calc(100vh - 56px);\n  position: relative;\n  align-items: center;\n}\n.personal-chat__content .chatSend-leftin {\n  width: 22px;\n  height: 20px;\n}\n.personal-chat__content--list {\n  flex: 1 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding-block-start: 24px;\n  width: 100%;\n}\n.personal-chat__header--info {\n  gap: 12px;\n  display: flex;\n  align-items: center;\n}\n.personal-chat__header--info img {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: contain;\n  object-position: center center;\n}\n.personal-chat__header--info p {\n  line-height: 1;\n  color: #fff;\n}\n.personal-chat__header--info-right-member {\n  line-height: 1;\n}\n.personal-chat__header--info-right-member span {\n  font-size: 12px;\n  line-height: 1;\n  padding-left: 4px;\n}\n.personal-chat__header--search {\n  background-color: #101a25;\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  border-radius: 8px;\n  flex: 1;\n  gap: 8px;\n}\n.personal-chat__header--search svg {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n}\n.personal-chat__header--search input {\n  flex: 1;\n  border: none;\n  outline: none;\n  background-color: #101a25;\n  color: #fff;\n}\n.personal-chat .sendBtn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background-color: var(--primary);\n  cursor: pointer;\n}\n.personal-chat .sendBtn.disabled {\n  cursor: not-allowed;\n  filter: grayscale(100%);\n}\n.personal-chat .more-btn {\n  font-size: 0;\n  position: relative;\n}\n.personal-chat .more-btn > svg {\n  width: 16px;\n  height: 16px;\n}\n.personal-chat .more-btn .more-btn-box {\n  position: absolute;\n  bottom: 28px;\n  width: 10rem;\n  background: #17191c;\n  margin-left: 8px;\n  color: #fff;\n  padding: 8px 16px;\n  border-radius: 14px;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.8);\n  font-size: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 3;\n  text-align: center;\n}\n.personal-chat .right_toolBar {\n  display: flex;\n}\n.personal-chat .right_toolBar .linkSvg {\n  fill: #fff;\n  cursor: pointer;\n}\n.personal-chat .right_toolBar .tableSvg {\n  stroke: #fff;\n  cursor: pointer;\n}\n.personal-chat .right_toolBar .compareSvg {\n  stroke: #fff;\n  cursor: pointer;\n}\n.personal-chat .compare {\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n.personal-chat .compare .title {\n  font-size: 16px;\n}\n.personal-chat .compare .item {\n  display: flex;\n  padding: 8px;\n  background: #d8e0ef;\n  border-radius: 20px;\n}\n.personal-chat .compare .item .name {\n  color: #000;\n  font-size: 16px;\n  line-height: 1.5rem;\n  word-break: break-all;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n}\n.personal-chat .compare .item .desc {\n  font-size: 14px;\n  color: hsla(220, 5%, 13%, 0.3);\n}\n.personal-chat .fileUpload {\n  display: flex;\n}\n.personal-chat .fileUpload .name {\n  word-break: break-all;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  font-size: 16px;\n  color: #000;\n  padding-top: 7px;\n}\n.personal-chat .aiMsg {\n  font-size: 16px;\n  color: #fff;\n  font-weight: 500;\n}\n\n.self_chat_txt_box {\n  background: var(--primary);\n  border-radius: 16px 2px 16px 16px;\n  padding: 8px 16px;\n  color: rgb(0, 0, 0);\n  width: 100%;\n  word-break: break-word;\n}\n\n.other_chat_txt_box {\n  background: rgb(45, 50, 62);\n  border-radius: 2px 16px 16px 16px;\n  padding: 8px 16px;\n  color: #fff;\n  width: 100%;\n  word-break: break-word;\n}\n\n.chat-send-box {\n  position: relative;\n  width: 100%;\n}\n.chat-send-box .emoji-picker {\n  position: absolute;\n  bottom: 100%;\n  z-index: 1000;\n}\n\n.msg_quoted {\n  align-items: flex-start;\n  display: flex;\n  margin-bottom: 4px;\n  width: 100%;\n  gap: 8px;\n}\n.msg_quoted > img {\n  border-radius: 50%;\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  object-fit: cover;\n}\n.msg_quoted .msg_quoted_main span {\n  font-size: 12px;\n}\n.msg_quoted .msg_quoted_main > div {\n  border-radius: 3px 16px 16px 16px;\n  padding: 8px 16px;\n  word-break: break-all;\n}\n.msg_quoted .msg_quoted_main > div p {\n  font-size: 12px;\n}\n\n.group_chat_box > span {\n  font-size: 14px;\n  line-height: 1;\n}\n\n@media screen and (max-width: 768px) {\n  .chatSend-content {\n    flex-wrap: wrap;\n  }\n  .chatSend-rightin {\n    margin-left: auto;\n  }\n}\n.backBtn {\n  width: 20px;\n  cursor: pointer;\n}\n\n.chatmessage-chat_content.self .avatar {\n  display: none;\n}.compare-files-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.compare-files-modal-header span {\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 700;\n  color: #fff;\n}\n.compare-files-modal-header button {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n}\n.compare-files-modal-bot {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  align-items: center;\n  margin-top: 1rem;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 700;\n}\n.compare-files-modal-bot .logo {\n  fill: var(--primary);\n}\n.compare-files-modal-document {\n  display: flex;\n  justify-content: space-between;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n.compare-files-modal-document li {\n  gap: 2rem;\n  width: 100%;\n  height: 100%;\n}\n.compare-files-modal-document li button {\n  width: 100%;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  margin: auto;\n  gap: 0.5rem;\n  align-items: center;\n  padding-top: 1.75rem;\n  padding-bottom: 3rem;\n  padding-left: 2.75rem;\n  padding-right: 2.75rem;\n  background-color: rgba(31, 32, 34, 0.8);\n}\n.compare-files-modal-document li button h5 {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n  line-height: 1.9rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 0;\n  word-break: break-word;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  font-weight: 500;\n  color: var(--foreground);\n}\n.compare-files-modal-document li button h5 span {\n  color: var(--primary);\n}\n.compare-files-modal-document li button p {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  color: rgb(140, 140, 140);\n}\n.compare-files-modal-start {\n  display: flex;\n  justify-content: center;\n  margin-top: 2rem;\n}\n.compare-files-modal-start button {\n  font-weight: 600;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 500;\n  color: #000;\n  background-color: var(--primary);\n  border-radius: 14px;\n  width: 9rem;\n  height: 3rem;\n}\n\n.no-file {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n}\n.no-file-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.no-file-content img {\n  margin-bottom: 2rem;\n}\n.no-file-content h3 {\n  color: var(--foreground);\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n}\n.no-file-content p {\n  color: rgba(248, 250, 252, 0.2);\n  font-size: 1rem;\n  line-height: 1.5rem;\n  text-align: center;\n  margin-bottom: 2rem;\n}\n.no-file-content button {\n  font-weight: 500;\n  background-color: var(--primary);\n  border-radius: 14px;\n  width: 9rem;\n  height: 3rem;\n}\n.no-file-content input[type=file] {\n  display: none;\n}\n\n@media (min-width: 1024px) {\n  .compare-files-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .compare-files-modal-header span {\n    font-size: 1.5rem;\n    line-height: 2rem;\n    font-weight: 700;\n    color: #fff;\n  }\n  .compare-files-modal-header button {\n    padding: 0;\n    background-color: transparent;\n    border: none;\n  }\n  .compare-files-modal-bot {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    align-items: center;\n    margin-top: 4rem;\n    font-size: 1.875rem;\n    line-height: 2.25rem;\n    font-weight: 700;\n  }\n  .compare-files-modal-document {\n    display: flex;\n    justify-content: space-between;\n    padding-left: 2.75rem;\n    padding-right: 2.75rem;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap: 4rem;\n    margin-top: 2rem;\n  }\n  .compare-files-modal-document li {\n    gap: 2rem;\n    width: 422px;\n    height: 232px;\n  }\n  .compare-files-modal-document li button {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    align-items: center;\n    padding-top: 1.75rem;\n    padding-bottom: 3rem;\n    padding-left: 2.75rem;\n    padding-right: 2.75rem;\n    background-color: rgba(31, 32, 34, 0.8);\n  }\n  .compare-files-modal-document li button h5 {\n    font-size: 1.125rem;\n    line-height: 1.75rem;\n    line-height: 1.9rem;\n    margin: 0;\n    font-weight: 500;\n  }\n  .compare-files-modal-document li button p {\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n    color: rgb(140, 140, 140);\n  }\n}ul {\n  list-style: none;\n}\n\n.text-sm {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.text-base, .form-control input,\n.form-control textarea, .form-control label, .edit-bot-modal-content button[type=submit] {\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n.text-lg {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n}\n\n.text-xs {\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n\n.text-xl {\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n}\n\n.text-2xl, .edit-bot-modal-header span {\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n\n.text-3xl {\n  font-size: 1.875rem;\n  line-height: 2.25rem;\n}\n\n.edit-bot-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.edit-bot-modal-header span {\n  font-weight: 700;\n  color: #fff;\n}\n.edit-bot-modal-header button {\n  background-color: transparent;\n  border: none;\n  outline: none;\n}\n.edit-bot-modal-content {\n  height: 70vh;\n  padding: 1rem 0.5rem;\n  overflow: auto;\n}\n.edit-bot-modal-content__avatar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n}\n.edit-bot-modal-content__avatar-content {\n  width: 88px;\n  height: 88px;\n  position: relative;\n  cursor: pointer;\n}\n.edit-bot-modal-content__avatar-content .upload-svg {\n  width: 33px;\n  height: 33px;\n  right: -6px;\n  bottom: -6px;\n  position: absolute;\n}\n.edit-bot-modal-content__avatar-content img,\n.edit-bot-modal-content__avatar-content svg:not(.upload-svg) {\n  width: 100%;\n  height: 100%;\n  border-radius: 28px;\n}\n.edit-bot-modal-content__avatar-content input[type=file] {\n  display: none;\n}\n.edit-bot-modal-content button[type=submit] {\n  margin-top: 2rem;\n  padding: 0.5rem 1rem;\n  border-radius: 14px;\n  width: 100%;\n  background-color: var(--primary);\n  font-weight: 500;\n  height: 60px;\n}\n\n.form-control {\n  display: flex;\n  flex-direction: column;\n  margin-top: 1.25rem;\n  gap: 0.5rem;\n}\n.form-control label {\n  text-indent: 0.2rem;\n}\n.form-control input,\n.form-control textarea {\n  min-height: 56px;\n  text-indent: 1rem;\n  width: 100%;\n  border-radius: 14px;\n  background-color: #1f2123;\n  caret-color: #fff;\n  outline: none;\n  border: none;\n  color: #fff;\n}\n.form-control textarea {\n  resize: none;\n  height: 94px;\n}\n.form-control p {\n  color: var(--error);\n}\n\n.form-control-switch {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 1.25rem;\n}\n\n.loading-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: auto;\n  height: 100%;\n}\n\n.flex-wrapper {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.avatar-wrapper {\n  border-radius: 28px;\n  overflow: hidden;\n  background-color: var(--primary);\n}\n.avatar-wrapper img {\n  display: block;\n}\n\n.rc-switch {\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  width: 44px;\n  height: 22px;\n  line-height: 20px;\n  padding: 0;\n  vertical-align: middle;\n  border-radius: 20px 20px;\n  border: 1px solid #ccc;\n  background-color: #ccc;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  overflow: hidden;\n}\n.rc-switch-inner-checked, .rc-switch-inner-unchecked {\n  color: #fff;\n  font-size: 12px;\n  position: absolute;\n  top: 0;\n  transition: left 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n}\n.rc-switch-inner-checked {\n  left: -14px;\n}\n.rc-switch-inner-unchecked {\n  left: 24px;\n}\n.rc-switch:after {\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  left: 2px;\n  top: 1px;\n  border-radius: 50% 50%;\n  background-color: #fff;\n  content: " ";\n  cursor: pointer;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.26);\n  transform: scale(1);\n  transition: left 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  animation-timing-function: cubic-bezier(0.35, 0, 0.25, 1);\n  animation-duration: 0.3s;\n  animation-name: rcSwitchOff;\n}\n.rc-switch:hover:after {\n  transform: scale(1.1);\n  animation-name: rcSwitchOn;\n}\n.rc-switch:focus {\n  outline: none;\n}\n.rc-switch-checked {\n  border: 1px solid var(--primary);\n  background-color: var(--primary);\n}\n.rc-switch-checked .rc-switch-inner-checked {\n  left: 6px;\n}\n.rc-switch-checked .rc-switch-inner-unchecked {\n  left: 44px;\n}\n.rc-switch-checked:after {\n  left: 22px;\n}\n.rc-switch-disabled {\n  cursor: no-drop;\n  background: #ccc;\n  border-color: #ccc;\n}\n.rc-switch-disabled:after {\n  background: #9e9e9e;\n  animation-name: none;\n  cursor: no-drop;\n}\n.rc-switch-disabled:hover:after {\n  transform: scale(1);\n  animation-name: none;\n}\n.rc-switch-label {\n  display: inline-block;\n  line-height: 20px;\n  font-size: 14px;\n  padding-left: 10px;\n  vertical-align: middle;\n  white-space: normal;\n  pointer-events: none;\n  user-select: text;\n}\n\n@keyframes rcSwitchOn {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.25);\n  }\n  100% {\n    transform: scale(1.1);\n  }\n}\n@keyframes rcSwitchOff {\n  0% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}ul {\n  list-style: none;\n}\n\n.text-sm {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.text-base, .files-modal-list .item .box .content .name, .files-modal-list .item .top .menu .btn {\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n.text-lg {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n}\n\n.text-xs, .files-modal-list .item .box .content .desc {\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n\n.text-xl {\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n}\n\n.text-2xl, .files-modal-header span {\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n\n.text-3xl, .files-modal-bot {\n  font-size: 1.875rem;\n  line-height: 2.25rem;\n}\n\n.files-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  height: 100%;\n}\n.files-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.files-modal-header span {\n  font-weight: 700;\n  color: #fff;\n}\n.files-modal-header button {\n  background-color: transparent;\n  border: none;\n  outline: none;\n}\n.files-modal-button-group {\n  display: flex;\n  flex-direction: row-reverse;\n}\n.files-modal-button-group button {\n  padding: 0.8rem 1.2rem;\n  border-radius: 8px;\n  background-color: var(--primary);\n  font-size: 18px;\n  cursor: pointer;\n}\n.files-modal-content {\n  flex: 1;\n}\n.files-modal-list .item {\n  margin-bottom: 1rem;\n  background: hsl(220, 5%, 13%);\n  padding: 1.5rem 0.5rem;\n  border-radius: 1rem;\n  border-width: 1px;\n  border-style: solid;\n  border-color: transparent;\n}\n.files-modal-list .item.check {\n  border-color: hsl(140, 43%, 55%);\n}\n.files-modal-list .item .check_icon {\n  font-size: 0;\n  cursor: pointer;\n}\n.files-modal-list .item .check_icon svg {\n  stroke: hsla(210, 40%, 98%, 0.2);\n}\n.files-modal-list .item .check_icon .check {\n  stroke: hsl(140, 43%, 55%);\n  fill: hsl(140, 43%, 55%);\n}\n.files-modal-list .item .check_icon.mobile {\n  display: block;\n  margin-left: 1.5rem;\n  margin-right: 1rem;\n}\n.files-modal-list .item .check_icon.pc {\n  display: none;\n}\n.files-modal-list .item .top {\n  display: flex;\n  justify-content: space-between;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  position: relative;\n}\n.files-modal-list .item .top .file_action {\n  margin-left: auto;\n  padding: 0 0.6rem;\n  cursor: pointer;\n}\n.files-modal-list .item .top .menu {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  z-index: 50;\n  top: 1.5rem;\n  background: #fff;\n  padding: 6px;\n  border-radius: 14px;\n  right: 0;\n}\n.files-modal-list .item .top .menu .btn {\n  padding-top: 6px;\n  padding-bottom: 6px;\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n  cursor: pointer;\n  border-radius: 10px;\n  text-align: center;\n  animation-duration: 150ms;\n  transition-duration: 150ms;\n  color: #000;\n}\n.files-modal-list .item .top .menu .btn.delete:hover {\n  background: hsl(0, 68%, 60%);\n  color: #fff;\n}\n.files-modal-list .item .top .menu .btn.download:hover {\n  background: hsl(140, 43%, 55%);\n  color: #fff;\n}\n.files-modal-list .item .box {\n  align-items: center;\n  display: flex;\n}\n.files-modal-list .item .box .file-img {\n  display: flex;\n  justify-content: center;\n}\n.files-modal-list .item .box .file-img img {\n  flex-shrink: 0;\n  margin: 0 auto;\n}\n.files-modal-list .item .box .content {\n  flex: 1 1 0%;\n}\n.files-modal-list .item .box .content .name {\n  color: #fff;\n  word-break: break-all;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  min-height: 48px;\n}\n.files-modal-list .item .box .content .line {\n  height: 1px;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(211, 211, 211, 0.1) 50%, rgba(255, 255, 255, 0) 100%);\n  margin-top: 1rem;\n  width: 100%;\n  display: none;\n}\n.files-modal-list .item .box .content .desc {\n  display: flex;\n  margin-top: 0.2rem;\n  color: rgba(255, 255, 255, 0.6);\n}\n.files-modal-list .item .box .content .desc .date {\n  margin-left: 1rem;\n}\n.files-modal-bot {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  align-items: center;\n  margin-top: 4rem;\n  font-weight: 700;\n}\n\n@media (min-width: 640px) {\n  .files-modal-list {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 1rem;\n  }\n  .files-modal-list .item .check_icon.pc {\n    display: block;\n  }\n  .files-modal-list .item .check_icon.mobile {\n    display: none;\n  }\n  .files-modal-list .item .top .check_icon {\n    display: block;\n  }\n  .files-modal-list .item .top .menu {\n    right: -70px;\n  }\n  .files-modal-list .item .box {\n    display: block;\n  }\n  .files-modal-list .item .box .content .name {\n    text-align: center;\n    padding-left: 2rem;\n    padding-right: 2rem;\n    margin-top: 1.5rem;\n  }\n  .files-modal-list .item .box .content .line {\n    display: block;\n  }\n  .files-modal-list .item .box .content .desc {\n    padding-left: 1rem;\n    padding-right: 1rem;\n    justify-content: space-between;\n    margin-top: 2rem;\n  }\n}\n@media (min-width: 768px) {\n  .files-modal-list {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 1rem;\n  }\n}\n@media (min-width: 1024px) {\n  .files-modal-list {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 1rem;\n  }\n}\n@media (min-width: 1280px) {\n  .files-modal-list {\n    display: grid;\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n    gap: 1rem;\n  }\n}ul {\n  list-style: none;\n}\n\n.text-sm {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.text-base, .fill-form-modal-list .item .box .content .name, .fill-form-modal-list .item .top .menu .btn {\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n.text-lg {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n}\n\n.text-xs, .fill-form-modal-list .item .box .content .desc {\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n\n.text-xl {\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n}\n\n.text-2xl, .fill-form-modal-header span {\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n\n.text-3xl, .fill-form-modal-bot {\n  font-size: 1.875rem;\n  line-height: 2.25rem;\n}\n\n.fill-form-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  height: 100%;\n}\n.fill-form-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.fill-form-modal-header span {\n  font-weight: 700;\n  color: #fff;\n}\n.fill-form-modal-header button {\n  background-color: transparent;\n  border: none;\n  outline: none;\n}\n.fill-form-modal-button-group {\n  display: flex;\n  flex-direction: row-reverse;\n}\n.fill-form-modal-button-group button {\n  padding: 0.8rem 1.2rem;\n  border-radius: 8px;\n  background-color: var(--primary);\n  font-size: 18px;\n  cursor: pointer;\n}\n.fill-form-modal-content {\n  flex: 1;\n}\n.fill-form-modal-list .item {\n  margin-bottom: 1rem;\n  background: hsl(220, 5%, 13%);\n  padding: 1.5rem 0.5rem;\n  border-radius: 1rem;\n  border-width: 1px;\n  border-style: solid;\n  border-color: transparent;\n}\n.fill-form-modal-list .item.check {\n  border-color: hsl(140, 43%, 55%);\n}\n.fill-form-modal-list .item .check_icon {\n  font-size: 0;\n  cursor: pointer;\n}\n.fill-form-modal-list .item .check_icon svg {\n  stroke: hsla(210, 40%, 98%, 0.2);\n}\n.fill-form-modal-list .item .check_icon .check {\n  stroke: hsl(140, 43%, 55%);\n  fill: hsl(140, 43%, 55%);\n}\n.fill-form-modal-list .item .check_icon.mobile {\n  display: block;\n  margin-left: 1.5rem;\n  margin-right: 1rem;\n}\n.fill-form-modal-list .item .check_icon.pc {\n  display: none;\n}\n.fill-form-modal-list .item .top {\n  display: flex;\n  justify-content: space-between;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  position: relative;\n}\n.fill-form-modal-list .item .top .file_action {\n  margin-left: auto;\n  padding: 0 0.6rem;\n  cursor: pointer;\n}\n.fill-form-modal-list .item .top .menu {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  z-index: 50;\n  top: 1.5rem;\n  background: #fff;\n  padding: 6px;\n  border-radius: 14px;\n  right: 0;\n}\n.fill-form-modal-list .item .top .menu .btn {\n  padding-top: 6px;\n  padding-bottom: 6px;\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n  cursor: pointer;\n  border-radius: 10px;\n  text-align: center;\n  animation-duration: 150ms;\n  transition-duration: 150ms;\n  color: #000;\n}\n.fill-form-modal-list .item .top .menu .btn.delete:hover {\n  background: hsl(0, 68%, 60%);\n  color: #fff;\n}\n.fill-form-modal-list .item .top .menu .btn.download:hover {\n  background: hsl(140, 43%, 55%);\n  color: #fff;\n}\n.fill-form-modal-list .item .box {\n  align-items: center;\n  display: flex;\n}\n.fill-form-modal-list .item .box .file-img {\n  display: flex;\n  justify-content: center;\n}\n.fill-form-modal-list .item .box .file-img img {\n  flex-shrink: 0;\n  margin: 0 auto;\n}\n.fill-form-modal-list .item .box .content {\n  flex: 1 1 0%;\n}\n.fill-form-modal-list .item .box .content .name {\n  color: #fff;\n  word-break: break-all;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  min-height: 48px;\n}\n.fill-form-modal-list .item .box .content .line {\n  height: 1px;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(211, 211, 211, 0.1) 50%, rgba(255, 255, 255, 0) 100%);\n  margin-top: 1rem;\n  width: 100%;\n  display: none;\n}\n.fill-form-modal-list .item .box .content .desc {\n  display: flex;\n  margin-top: 0.2rem;\n  color: rgba(255, 255, 255, 0.6);\n}\n.fill-form-modal-list .item .box .content .desc .date {\n  margin-left: 1rem;\n}\n.fill-form-modal-bot {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  align-items: center;\n  margin-top: 4rem;\n  font-weight: 700;\n}\n\n@media (min-width: 640px) {\n  .fill-form-modal-list {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 1rem;\n  }\n  .fill-form-modal-list .item .check_icon.pc {\n    display: block;\n  }\n  .fill-form-modal-list .item .check_icon.mobile {\n    display: none;\n  }\n  .fill-form-modal-list .item .top .check_icon {\n    display: block;\n  }\n  .fill-form-modal-list .item .top .menu {\n    right: -70px;\n  }\n  .fill-form-modal-list .item .box {\n    display: block;\n  }\n  .fill-form-modal-list .item .box .content .name {\n    text-align: center;\n    padding-left: 2rem;\n    padding-right: 2rem;\n    margin-top: 1.5rem;\n  }\n  .fill-form-modal-list .item .box .content .line {\n    display: block;\n  }\n  .fill-form-modal-list .item .box .content .desc {\n    padding-left: 1rem;\n    padding-right: 1rem;\n    justify-content: space-between;\n    margin-top: 2rem;\n  }\n}\n@media (min-width: 768px) {\n  .fill-form-modal-list {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 1rem;\n  }\n}\n@media (min-width: 1024px) {\n  .fill-form-modal-list {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 1rem;\n  }\n}\n@media (min-width: 1280px) {\n  .fill-form-modal-list {\n    display: grid;\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n    gap: 1rem;\n  }\n}.removeChatroom-modal {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.removeChatroom-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.removeChatroom-modal-header span {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n  font-weight: 700;\n  color: #fff;\n}\n.removeChatroom-modal-header button {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  margin-left: auto;\n}\n.removeChatroom-modal-content {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n  font-weight: 500;\n}\n.removeChatroom-modal-content span {\n  color: var(--error);\n}\n.removeChatroom-modal-button {\n  display: flex;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-top: 1rem;\n}\n.removeChatroom-modal-button button {\n  width: 90px;\n  height: 42px;\n  font-weight: 500;\n  border-radius: 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  color: var(--foreground);\n}\n.removeChatroom-modal-button__cancel {\n  background-color: #8c8c8c;\n}\n.removeChatroom-modal-button__remove {\n  background-color: var(--error);\n}.remove-file {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.remove-file-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.remove-file-header span {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n  font-weight: 700;\n  color: #fff;\n}\n.remove-file-header button {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n}\n.remove-file-content {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n  font-weight: 500;\n}\n.remove-file-content span {\n  color: var(--error);\n}\n.remove-file-button {\n  display: flex;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-top: 1rem;\n}\n.remove-file-button button {\n  width: 90px;\n  height: 42px;\n  font-weight: 500;\n  border-radius: 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  color: var(--foreground);\n}\n.remove-file-button__cancel {\n  background-color: #8c8c8c;\n}\n.remove-file-button__remove {\n  background-color: var(--error);\n}.newFriendsModal-modal-header {\n  display: flex;\n  height: 48px;\n  width: 100%;\n  background: #000;\n  justify-content: space-between;\n  align-items: center;\n}\n.newFriendsModal-modal-header button {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  padding: 0 16px;\n}\n.newFriendsModal-modal-header .title {\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 600;\n}\n.newFriendsModal-modal-content {\n  padding: 16px;\n}\n.newFriendsModal-modal-content .search-bar {\n  width: 100%;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  background: #000000;\n  padding-left: 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n.newFriendsModal-modal-content .search-bar input {\n  flex: 1;\n  outline: none;\n  border: none;\n  background: #000000;\n  border-radius: 8px;\n  color: #FFFFFF;\n  height: 100%;\n}\n.newFriendsModal-modal-content .search-bar input::placeholder {\n  color: #A6A9B8;\n  font-weight: 400;\n  font-size: 16px;\n}\n.newFriendsModal-modal-content .search-bar input:-webkit-autofill {\n  background-color: #000 !important;\n}\n.newFriendsModal-modal-content .search-bar span {\n  flex-shrink: 0;\n  width: 40px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.newFriendsModal-modal-list li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  padding: 4px 0;\n}\n.newFriendsModal-modal-list li > div {\n  display: flex;\n  align-items: center;\n}\n.newFriendsModal-modal-list li > div img {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  margin-right: 16px;\n}\n.newFriendsModal-modal-list li > span {\n  flex: 1;\n  height: 48px;\n  font-weight: 600;\n  font-size: 14px;\n  color: #FFFFFF;\n  border-bottom: 1px solid #334663;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.newFriendsModal-modal-list li > span .name {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 220px;\n}\n.newFriendsModal-modal-list li > span .invite {\n  padding: 4px 8px;\n  border: 1px solid var(--primary);\n  border-radius: 8px;\n  font-weight: 400;\n  color: var(--primary);\n  font-size: 12px;\n}\n.newFriendsModal-modal-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin-top: 60px;\n}\n.newFriendsModal-modal-error p {\n  height: 22px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  line-height: 22px;\n  color: #A6A9B8;\n  margin-top: 25px;\n}\n.newFriendsModal-modal .loader {\n  margin-left: auto;\n  margin-right: auto;\n}.invitation-list-modal-header {\n  display: flex;\n  height: 48px;\n  width: 100%;\n  background: #000;\n  justify-content: space-between;\n  align-items: center;\n}\n.invitation-list-modal-header button {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  padding: 0 16px;\n}\n.invitation-list-modal-header .title {\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 600;\n}\n.invitation-list-modal-content {\n  padding: 16px;\n}\n.invitation-list-modal-list li {\n  display: flex;\n  flex-direction: column;\n  align-items: normal;\n  padding: 16px;\n  border-radius: 12px;\n  background: #1E232D;\n  position: relative;\n  margin-bottom: 1rem;\n}\n.invitation-list-modal-list .top {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n}\n.invitation-list-modal-list .top > img {\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  margin-right: 12px;\n}\n.invitation-list-modal-list .top > div {\n  display: flex;\n  flex-direction: column;\n}\n.invitation-list-modal-list .top > div > span {\n  color: #FFF;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 600;\n  min-height: 22px;\n}\n.invitation-list-modal-list .top > div > p {\n  color: #898A8D;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 400;\n}\n.invitation-list-modal-list .bottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.invitation-list-modal-list .bottom .date {\n  font-weight: 400;\n  font-size: 12px;\n  color: #979797;\n  font-style: initial;\n}\n.invitation-list-modal-list .bottom .btnGroup {\n  display: flex;\n}\n.invitation-list-modal-list .bottom .btn {\n  background: transparent;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 7px 12px;\n  border-radius: 6px;\n  font-family: "Open";\n  font-weight: 400;\n  font-size: 12px;\n  min-width: 70px;\n}\n.invitation-list-modal-list .bottom .btn.accept {\n  border: 1px solid var(--primary);\n  color: var(--primary);\n  margin-right: 10px;\n}\n.invitation-list-modal-list .bottom .btn.pending {\n  background: rgba(66, 224, 167, 0.1);\n  color: #42E0A7;\n}\n.invitation-list-modal-list .bottom .btn.reject {\n  background: var(--primary);\n  color: #2D323E;\n}\n.invitation-list-modal-list .bottom .btn.accepted {\n  background: #2D323E;\n  color: #fff;\n}\n.invitation-list-modal-list .bottom .btn.rejected {\n  color: #AA6060;\n  background: rgba(170, 96, 96, 0.1);\n}\n.invitation-list-modal-list .bottom .btn:disabled {\n  cursor: auto;\n}\n.invitation-list-modal-content-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin-top: 60px;\n}\n.invitation-list-modal-content-empty p {\n  height: 22px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  line-height: 22px;\n  color: #A6A9B8;\n  margin-top: 25px;\n}'));
      document.head.appendChild(elementStyle);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
import { j as jsxRuntimeExports, h as CloseSVG, i as DallmLogo, N as NullFileSVG, k as HasFileSVG, l as EditAvatarSVG, C as ChatSVG, m as CheckSVG, F as FileAction, d as dayjs, S as SearchSVG } from "./dayjs.min.js";
import * as React from "react";
import React__default, { useEffect, useState, useRef, useTransition, useMemo } from "react";
import { g as getDefaultExportFromCjs, a as getAugmentedNamespace, b as __rest, u as useChatroom, _ as __awaiter, c as commonjsGlobal, C as ChatContext } from "./_commonjsHelpers.js";
import { u as useSupabase } from "./useSupabase.js";
import require$$1 from "react-dom";
import classNames from "classnames";
import { L as Loading, f as formatFileSize, g as getFileType } from "./file.js";
function _mergeNamespaces(n, m) {
  for (var i = 0; i < m.length; i++) {
    const e = m[i];
    if (typeof e !== "string" && !Array.isArray(e)) {
      for (const k in e) {
        if (k !== "default" && !(k in n)) {
          const d = Object.getOwnPropertyDescriptor(e, k);
          if (d) {
            Object.defineProperty(n, k, d.get ? d : {
              enumerable: true,
              get: () => e[k]
            });
          }
        }
      }
    }
  }
  return Object.freeze(Object.defineProperty(n, Symbol.toStringTag, { value: "Module" }));
}
var lib = { exports: {} };
var Modal$3 = {};
var propTypes$1 = { exports: {} };
var reactIs = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function(a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function(a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function(a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function(a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function(a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function(a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function(a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function(a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function(a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function(a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2["_" + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
        return test2[n];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      } else {
        return x !== x && y !== y;
      }
    }
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker2 = arrayOfTypeCheckers[i2];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs();
  var throwOnDirectAccess = true;
  propTypes$1.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes$1.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes$1.exports;
const index$1 = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
const propTypes = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: index$1
}, [propTypesExports]);
const require$$2$1 = /* @__PURE__ */ getAugmentedNamespace(propTypes);
var ModalPortal$2 = { exports: {} };
var focusManager$1 = {};
var tabbable$2 = { exports: {} };
(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = findTabbableDescendants;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  var DISPLAY_NONE = "none";
  var DISPLAY_CONTENTS = "contents";
  var tabbableNode = /input|select|textarea|button|object|iframe/;
  function isNotOverflowing(element, style) {
    return style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0;
  }
  function hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    if (zeroSize && !element.innerHTML) return true;
    try {
      var style = window.getComputedStyle(element);
      var displayValue = style.getPropertyValue("display");
      return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
    } catch (exception) {
      console.warn("Failed to inspect element style");
      return false;
    }
  }
  function visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while (parentElement) {
      if (parentElement === document.body) break;
      if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
      if (hidesContents(parentElement)) return false;
      parentElement = parentElement.parentNode;
    }
    return true;
  }
  function focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && visible(element);
  }
  function tabbable2(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = void 0;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
  }
  function findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
      return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter(tabbable2);
  }
  module.exports = exports["default"];
})(tabbable$2, tabbable$2.exports);
var tabbableExports = tabbable$2.exports;
const tabbable = /* @__PURE__ */ getDefaultExportFromCjs(tabbableExports);
const tabbable$1 = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: tabbable
}, [tabbableExports]);
const require$$0$3 = /* @__PURE__ */ getAugmentedNamespace(tabbable$1);
Object.defineProperty(focusManager$1, "__esModule", {
  value: true
});
var resetState_1$3 = focusManager$1.resetState = resetState$4;
var log_1$3 = focusManager$1.log = log$4;
var handleBlur_1 = focusManager$1.handleBlur = handleBlur;
var handleFocus_1 = focusManager$1.handleFocus = handleFocus;
var markForFocusLater_1 = focusManager$1.markForFocusLater = markForFocusLater;
var returnFocus_1 = focusManager$1.returnFocus = returnFocus;
var popWithoutFocus_1 = focusManager$1.popWithoutFocus = popWithoutFocus;
var setupScopedFocus_1 = focusManager$1.setupScopedFocus = setupScopedFocus;
var teardownScopedFocus_1 = focusManager$1.teardownScopedFocus = teardownScopedFocus;
var _tabbable = require$$0$3;
var _tabbable2 = _interopRequireDefault$4(_tabbable);
function _interopRequireDefault$4(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;
function resetState$4() {
  focusLaterElements = [];
}
function log$4() {
  if (process.env.NODE_ENV !== "production") {
    console.log("focusManager ----------");
    focusLaterElements.forEach(function(f) {
      var check = f || {};
      console.log(check.nodeName, check.className, check.id);
    });
    console.log("end focusManager ----------");
  }
}
function handleBlur() {
  needToFocus = true;
}
function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    setTimeout(function() {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}
function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}
function setupScopedFocus(element) {
  modalElement = element;
  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}
function teardownScopedFocus() {
  modalElement = null;
  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}
const focusManager = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: focusManager$1,
  handleBlur: handleBlur_1,
  handleFocus: handleFocus_1,
  log: log_1$3,
  markForFocusLater: markForFocusLater_1,
  popWithoutFocus: popWithoutFocus_1,
  resetState: resetState_1$3,
  returnFocus: returnFocus_1,
  setupScopedFocus: setupScopedFocus_1,
  teardownScopedFocus: teardownScopedFocus_1
}, [focusManager$1]);
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(focusManager);
var scopeTab$2 = { exports: {} };
(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = scopeTab2;
  var _tabbable3 = require$$0$3;
  var _tabbable22 = _interopRequireDefault2(_tabbable3);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
  }
  function scopeTab2(node, event) {
    var tabbable2 = (0, _tabbable22.default)(node);
    if (!tabbable2.length) {
      event.preventDefault();
      return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable2[0];
    var tail = tabbable2[tabbable2.length - 1];
    var activeElement = getActiveElement();
    if (node === activeElement) {
      if (!shiftKey) return;
      target = tail;
    }
    if (tail === activeElement && !shiftKey) {
      target = head;
    }
    if (head === activeElement && shiftKey) {
      target = tail;
    }
    if (target) {
      event.preventDefault();
      target.focus();
      return;
    }
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    if (!isSafariDesktop) return;
    var x = tabbable2.indexOf(activeElement);
    if (x > -1) {
      x += shiftKey ? -1 : 1;
    }
    target = tabbable2[x];
    if (typeof target === "undefined") {
      event.preventDefault();
      target = shiftKey ? tail : head;
      target.focus();
      return;
    }
    event.preventDefault();
    target.focus();
  }
  module.exports = exports["default"];
})(scopeTab$2, scopeTab$2.exports);
var scopeTabExports = scopeTab$2.exports;
const scopeTab = /* @__PURE__ */ getDefaultExportFromCjs(scopeTabExports);
const scopeTab$1 = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: scopeTab
}, [scopeTabExports]);
const require$$3$1 = /* @__PURE__ */ getAugmentedNamespace(scopeTab$1);
var ariaAppHider$2 = {};
var __DEV__ = process.env.NODE_ENV !== "production";
var warning = function() {
};
if (__DEV__) {
  var printWarning = function printWarning2(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = "Warning: " + format.replace(/%s/g, function() {
      return args[argIndex++];
    });
    if (typeof console !== "undefined") {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {
    }
  };
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === void 0) {
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}
var warning_1 = warning;
const warning$1 = /* @__PURE__ */ getDefaultExportFromCjs(warning_1);
const warning$2 = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: warning$1
}, [warning_1]);
const require$$0$2 = /* @__PURE__ */ getAugmentedNamespace(warning$2);
var safeHTMLElement$1 = {};
var exenv$1 = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
(function(module) {
  (function() {
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
      canUseDOM,
      canUseWorkers: typeof Worker !== "undefined",
      canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
      canUseViewport: canUseDOM && !!window.screen
    };
    if (module.exports) {
      module.exports = ExecutionEnvironment;
    } else {
      window.ExecutionEnvironment = ExecutionEnvironment;
    }
  })();
})(exenv$1);
var exenvExports = exenv$1.exports;
const index = /* @__PURE__ */ getDefaultExportFromCjs(exenvExports);
const exenv = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: index
}, [exenvExports]);
const require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(exenv);
var SafeHTMLCollection_1;
var SafeNodeList_1;
Object.defineProperty(safeHTMLElement$1, "__esModule", {
  value: true
});
var canUseDOM_1 = safeHTMLElement$1.canUseDOM = SafeNodeList_1 = safeHTMLElement$1.SafeNodeList = SafeHTMLCollection_1 = safeHTMLElement$1.SafeHTMLCollection = void 0;
var _exenv = require$$0$1;
var _exenv2 = _interopRequireDefault$3(_exenv);
function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var EE = _exenv2.default;
var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
SafeHTMLCollection_1 = safeHTMLElement$1.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};
SafeNodeList_1 = safeHTMLElement$1.SafeNodeList = EE.canUseDOM ? window.NodeList : {};
canUseDOM_1 = safeHTMLElement$1.canUseDOM = EE.canUseDOM;
var _default$2 = safeHTMLElement$1.default = SafeHTMLElement;
const safeHTMLElement = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  get SafeHTMLCollection() {
    return SafeHTMLCollection_1;
  },
  get SafeNodeList() {
    return SafeNodeList_1;
  },
  get canUseDOM() {
    return canUseDOM_1;
  },
  default: _default$2
}, [safeHTMLElement$1]);
const require$$5$1 = /* @__PURE__ */ getAugmentedNamespace(safeHTMLElement);
Object.defineProperty(ariaAppHider$2, "__esModule", {
  value: true
});
var resetState_1$2 = ariaAppHider$2.resetState = resetState$3;
var log_1$2 = ariaAppHider$2.log = log$3;
var assertNodeList_1 = ariaAppHider$2.assertNodeList = assertNodeList;
var setElement_1 = ariaAppHider$2.setElement = setElement;
var validateElement_1 = ariaAppHider$2.validateElement = validateElement;
var hide_1 = ariaAppHider$2.hide = hide;
var show_1 = ariaAppHider$2.show = show;
var documentNotReadyOrSSRTesting_1 = ariaAppHider$2.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
var _warning = require$$0$2;
var _warning2 = _interopRequireDefault$2(_warning);
var _safeHTMLElement$1 = require$$5$1;
function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var globalElement = null;
function resetState$3() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function(element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function(element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}
function log$3() {
  if (process.env.NODE_ENV !== "production") {
    var check = globalElement || {};
    console.log("ariaAppHider ----------");
    console.log(check.nodeName, check.className, check.id);
    console.log("end ariaAppHider ----------");
  }
}
function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}
function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement$1.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}
function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
    return [];
  }
}
function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = void 0;
  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;
      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}
function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = void 0;
  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;
      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}
function documentNotReadyOrSSRTesting() {
  globalElement = null;
}
const ariaAppHider$1 = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  assertNodeList: assertNodeList_1,
  default: ariaAppHider$2,
  documentNotReadyOrSSRTesting: documentNotReadyOrSSRTesting_1,
  hide: hide_1,
  log: log_1$2,
  resetState: resetState_1$2,
  setElement: setElement_1,
  show: show_1,
  validateElement: validateElement_1
}, [ariaAppHider$2]);
const require$$4 = /* @__PURE__ */ getAugmentedNamespace(ariaAppHider$1);
var classList$1 = {};
var remove_1;
var add_1;
Object.defineProperty(classList$1, "__esModule", {
  value: true
});
var resetState_1$1 = classList$1.resetState = resetState$2;
var log_1$1 = classList$1.log = log$2;
var htmlClassList = {};
var docBodyClassList = {};
function removeClass(at, cls) {
  at.classList.remove(cls);
}
function resetState$2() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }
  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }
  htmlClassList = {};
  docBodyClassList = {};
}
function log$2() {
  if (process.env.NODE_ENV !== "production") {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";
    buffer += "<html /> (" + classes + "):\n  ";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n  ";
    }
    classes = document.body.className;
    buffer += "\n\ndoc.body (" + classes + "):\n  ";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n  ";
    }
    buffer += "\n";
    console.log(buffer);
  }
}
var incrementReference = function incrementReference2(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};
var decrementReference = function decrementReference2(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};
var trackClass = function trackClass2(classListRef, poll, classes) {
  classes.forEach(function(className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};
var untrackClass = function untrackClass2(classListRef, poll, classes) {
  classes.forEach(function(className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};
add_1 = classList$1.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};
remove_1 = classList$1.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};
const classList = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  get add() {
    return add_1;
  },
  default: classList$1,
  log: log_1$1,
  get remove() {
    return remove_1;
  },
  resetState: resetState_1$1
}, [classList$1]);
const require$$5 = /* @__PURE__ */ getAugmentedNamespace(classList);
var portalOpenInstances$2 = {};
Object.defineProperty(portalOpenInstances$2, "__esModule", {
  value: true
});
var log_1 = portalOpenInstances$2.log = log$1;
var resetState_1 = portalOpenInstances$2.resetState = resetState$1;
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var PortalOpenInstances = function PortalOpenInstances2() {
  var _this = this;
  _classCallCheck$1(this, PortalOpenInstances2);
  this.register = function(openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("React-Modal: Cannot register modal instance that's already open");
      }
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };
  this.deregister = function(openInstance) {
    var index2 = _this.openInstances.indexOf(openInstance);
    if (index2 === -1) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("React-Modal: Unable to deregister " + openInstance + " as it was never registered");
      }
      return;
    }
    _this.openInstances.splice(index2, 1);
    _this.emit("deregister");
  };
  this.subscribe = function(callback) {
    _this.subscribers.push(callback);
  };
  this.emit = function(eventType) {
    _this.subscribers.forEach(function(subscriber) {
      return subscriber(
        eventType,
        // shallow copy to avoid accidental mutation
        _this.openInstances.slice()
      );
    });
  };
  this.openInstances = [];
  this.subscribers = [];
};
var portalOpenInstances = new PortalOpenInstances();
function log$1() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function(p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}
function resetState$1() {
  portalOpenInstances = new PortalOpenInstances();
}
var _default$1 = portalOpenInstances$2.default = portalOpenInstances;
const portalOpenInstances$1 = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: _default$1,
  log: log_1,
  resetState: resetState_1
}, [portalOpenInstances$2]);
const require$$7 = /* @__PURE__ */ getAugmentedNamespace(portalOpenInstances$1);
var bodyTrap$1 = {};
Object.defineProperty(bodyTrap$1, "__esModule", {
  value: true
});
bodyTrap$1.resetState = resetState;
bodyTrap$1.log = log;
var _portalOpenInstances = require$$7;
var _portalOpenInstances2 = _interopRequireDefault$1(_portalOpenInstances);
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var before = void 0, after = void 0, instances = [];
function resetState() {
  var _arr = [before, after];
  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
function focusContent() {
  if (instances.length === 0) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("React-Modal: Open instances > 0 expected");
    }
    return;
  }
  instances[instances.length - 1].focusContent();
}
function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }
  instances = openInstances;
  if (instances.length > 0) {
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}
_portalOpenInstances2.default.subscribe(bodyTrap);
(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _react3 = React__default;
  var _propTypes3 = require$$2$1;
  var _propTypes22 = _interopRequireDefault2(_propTypes3);
  var _focusManager = require$$2;
  var focusManager2 = _interopRequireWildcard2(_focusManager);
  var _scopeTab = require$$3$1;
  var _scopeTab2 = _interopRequireDefault2(_scopeTab);
  var _ariaAppHider2 = require$$4;
  var ariaAppHider2 = _interopRequireWildcard2(_ariaAppHider2);
  var _classList = require$$5;
  var classList2 = _interopRequireWildcard2(_classList);
  var _safeHTMLElement3 = require$$5$1;
  var _safeHTMLElement22 = _interopRequireDefault2(_safeHTMLElement3);
  var _portalOpenInstances3 = require$$7;
  var _portalOpenInstances22 = _interopRequireDefault2(_portalOpenInstances3);
  function _interopRequireWildcard2(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  };
  var isTabKey = function isTabKey2(event) {
    return event.code === "Tab" || event.keyCode === 9;
  };
  var isEscKey = function isEscKey2(event) {
    return event.code === "Escape" || event.keyCode === 27;
  };
  var ariaHiddenInstances = 0;
  var ModalPortal2 = function(_Component) {
    _inherits2(ModalPortal3, _Component);
    function ModalPortal3(props) {
      _classCallCheck2(this, ModalPortal3);
      var _this = _possibleConstructorReturn2(this, (ModalPortal3.__proto__ || Object.getPrototypeOf(ModalPortal3)).call(this, props));
      _this.setOverlayRef = function(overlay) {
        _this.overlay = overlay;
        _this.props.overlayRef && _this.props.overlayRef(overlay);
      };
      _this.setContentRef = function(content) {
        _this.content = content;
        _this.props.contentRef && _this.props.contentRef(content);
      };
      _this.afterClose = function() {
        var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName2 = _this$props.bodyOpenClassName, parentSelector2 = _this$props.parentSelector;
        var parentDocument = parentSelector2 && parentSelector2().ownerDocument || document;
        bodyOpenClassName2 && classList2.remove(parentDocument.body, bodyOpenClassName2);
        htmlOpenClassName && classList2.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
        if (ariaHideApp && ariaHiddenInstances > 0) {
          ariaHiddenInstances -= 1;
          if (ariaHiddenInstances === 0) {
            ariaAppHider2.show(appElement);
          }
        }
        if (_this.props.shouldFocusAfterRender) {
          if (_this.props.shouldReturnFocusAfterClose) {
            focusManager2.returnFocus(_this.props.preventScroll);
            focusManager2.teardownScopedFocus();
          } else {
            focusManager2.popWithoutFocus();
          }
        }
        if (_this.props.onAfterClose) {
          _this.props.onAfterClose();
        }
        _portalOpenInstances22.default.deregister(_this);
      };
      _this.open = function() {
        _this.beforeOpen();
        if (_this.state.afterOpen && _this.state.beforeClose) {
          clearTimeout(_this.closeTimer);
          _this.setState({ beforeClose: false });
        } else {
          if (_this.props.shouldFocusAfterRender) {
            focusManager2.setupScopedFocus(_this.node);
            focusManager2.markForFocusLater();
          }
          _this.setState({ isOpen: true }, function() {
            _this.openAnimationFrame = requestAnimationFrame(function() {
              _this.setState({ afterOpen: true });
              if (_this.props.isOpen && _this.props.onAfterOpen) {
                _this.props.onAfterOpen({
                  overlayEl: _this.overlay,
                  contentEl: _this.content
                });
              }
            });
          });
        }
      };
      _this.close = function() {
        if (_this.props.closeTimeoutMS > 0) {
          _this.closeWithTimeout();
        } else {
          _this.closeWithoutTimeout();
        }
      };
      _this.focusContent = function() {
        return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
      };
      _this.closeWithTimeout = function() {
        var closesAt = Date.now() + _this.props.closeTimeoutMS;
        _this.setState({ beforeClose: true, closesAt }, function() {
          _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
        });
      };
      _this.closeWithoutTimeout = function() {
        _this.setState({
          beforeClose: false,
          isOpen: false,
          afterOpen: false,
          closesAt: null
        }, _this.afterClose);
      };
      _this.handleKeyDown = function(event) {
        if (isTabKey(event)) {
          (0, _scopeTab2.default)(_this.content, event);
        }
        if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
          event.stopPropagation();
          _this.requestClose(event);
        }
      };
      _this.handleOverlayOnClick = function(event) {
        if (_this.shouldClose === null) {
          _this.shouldClose = true;
        }
        if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
          if (_this.ownerHandlesClose()) {
            _this.requestClose(event);
          } else {
            _this.focusContent();
          }
        }
        _this.shouldClose = null;
      };
      _this.handleContentOnMouseUp = function() {
        _this.shouldClose = false;
      };
      _this.handleOverlayOnMouseDown = function(event) {
        if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
          event.preventDefault();
        }
      };
      _this.handleContentOnClick = function() {
        _this.shouldClose = false;
      };
      _this.handleContentOnMouseDown = function() {
        _this.shouldClose = false;
      };
      _this.requestClose = function(event) {
        return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
      };
      _this.ownerHandlesClose = function() {
        return _this.props.onRequestClose;
      };
      _this.shouldBeClosed = function() {
        return !_this.state.isOpen && !_this.state.beforeClose;
      };
      _this.contentHasFocus = function() {
        return document.activeElement === _this.content || _this.content.contains(document.activeElement);
      };
      _this.buildClassName = function(which, additional) {
        var classNames2 = (typeof additional === "undefined" ? "undefined" : _typeof2(additional)) === "object" ? additional : {
          base: CLASS_NAMES[which],
          afterOpen: CLASS_NAMES[which] + "--after-open",
          beforeClose: CLASS_NAMES[which] + "--before-close"
        };
        var className = classNames2.base;
        if (_this.state.afterOpen) {
          className = className + " " + classNames2.afterOpen;
        }
        if (_this.state.beforeClose) {
          className = className + " " + classNames2.beforeClose;
        }
        return typeof additional === "string" && additional ? className + " " + additional : className;
      };
      _this.attributesFromObject = function(prefix, items) {
        return Object.keys(items).reduce(function(acc, name) {
          acc[prefix + "-" + name] = items[name];
          return acc;
        }, {});
      };
      _this.state = {
        afterOpen: false,
        beforeClose: false
      };
      _this.shouldClose = null;
      _this.moveFromContentToOverlay = null;
      return _this;
    }
    _createClass2(ModalPortal3, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.isOpen) {
          this.open();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        if (process.env.NODE_ENV !== "production") {
          if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
            console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.');
          }
          if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
            console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.');
          }
        }
        if (this.props.isOpen && !prevProps.isOpen) {
          this.open();
        } else if (!this.props.isOpen && prevProps.isOpen) {
          this.close();
        }
        if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
          this.focusContent();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.state.isOpen) {
          this.afterClose();
        }
        clearTimeout(this.closeTimer);
        cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function beforeOpen() {
        var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName2 = _props.bodyOpenClassName, parentSelector2 = _props.parentSelector;
        var parentDocument = parentSelector2 && parentSelector2().ownerDocument || document;
        bodyOpenClassName2 && classList2.add(parentDocument.body, bodyOpenClassName2);
        htmlOpenClassName && classList2.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
        if (ariaHideApp) {
          ariaHiddenInstances += 1;
          ariaAppHider2.hide(appElement);
        }
        _portalOpenInstances22.default.register(this);
      }
      // Don't steal focus from inner elements
    }, {
      key: "render",
      value: function render() {
        var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
        var contentStyles = className ? {} : defaultStyles.content;
        var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
        if (this.shouldBeClosed()) {
          return null;
        }
        var overlayProps = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends2({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        };
        var contentProps = _extends2({
          id,
          ref: this.setContentRef,
          style: _extends2({}, contentStyles, this.props.style.content),
          className: this.buildClassName("content", className),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", _extends2({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        });
        var contentElement2 = this.props.contentElement(contentProps, children);
        return this.props.overlayElement(overlayProps, contentElement2);
      }
    }]);
    return ModalPortal3;
  }(_react3.Component);
  ModalPortal2.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  };
  ModalPortal2.propTypes = {
    isOpen: _propTypes22.default.bool.isRequired,
    defaultStyles: _propTypes22.default.shape({
      content: _propTypes22.default.object,
      overlay: _propTypes22.default.object
    }),
    style: _propTypes22.default.shape({
      content: _propTypes22.default.object,
      overlay: _propTypes22.default.object
    }),
    className: _propTypes22.default.oneOfType([_propTypes22.default.string, _propTypes22.default.object]),
    overlayClassName: _propTypes22.default.oneOfType([_propTypes22.default.string, _propTypes22.default.object]),
    parentSelector: _propTypes22.default.func,
    bodyOpenClassName: _propTypes22.default.string,
    htmlOpenClassName: _propTypes22.default.string,
    ariaHideApp: _propTypes22.default.bool,
    appElement: _propTypes22.default.oneOfType([_propTypes22.default.instanceOf(_safeHTMLElement22.default), _propTypes22.default.instanceOf(_safeHTMLElement3.SafeHTMLCollection), _propTypes22.default.instanceOf(_safeHTMLElement3.SafeNodeList), _propTypes22.default.arrayOf(_propTypes22.default.instanceOf(_safeHTMLElement22.default))]),
    onAfterOpen: _propTypes22.default.func,
    onAfterClose: _propTypes22.default.func,
    onRequestClose: _propTypes22.default.func,
    closeTimeoutMS: _propTypes22.default.number,
    shouldFocusAfterRender: _propTypes22.default.bool,
    shouldCloseOnOverlayClick: _propTypes22.default.bool,
    shouldReturnFocusAfterClose: _propTypes22.default.bool,
    preventScroll: _propTypes22.default.bool,
    role: _propTypes22.default.string,
    contentLabel: _propTypes22.default.string,
    aria: _propTypes22.default.object,
    data: _propTypes22.default.object,
    children: _propTypes22.default.node,
    shouldCloseOnEsc: _propTypes22.default.bool,
    overlayRef: _propTypes22.default.func,
    contentRef: _propTypes22.default.func,
    id: _propTypes22.default.string,
    overlayElement: _propTypes22.default.func,
    contentElement: _propTypes22.default.func,
    testId: _propTypes22.default.string
  };
  exports.default = ModalPortal2;
  module.exports = exports["default"];
})(ModalPortal$2, ModalPortal$2.exports);
var ModalPortalExports = ModalPortal$2.exports;
const ModalPortal = /* @__PURE__ */ getDefaultExportFromCjs(ModalPortalExports);
const ModalPortal$1 = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: ModalPortal
}, [ModalPortalExports]);
const require$$3 = /* @__PURE__ */ getAugmentedNamespace(ModalPortal$1);
function componentWillMount() {
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== void 0) {
    this.setState(state);
  }
}
function componentWillReceiveProps(nextProps) {
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== void 0 ? state : null;
  }
  this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component) {
  var prototype = Component.prototype;
  if (!prototype || !prototype.isReactComponent) {
    throw new Error("Can only polyfill class components");
  }
  if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") {
    return Component;
  }
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === "function") {
    foundWillMountName = "componentWillMount";
  } else if (typeof prototype.UNSAFE_componentWillMount === "function") {
    foundWillMountName = "UNSAFE_componentWillMount";
  }
  if (typeof prototype.componentWillReceiveProps === "function") {
    foundWillReceivePropsName = "componentWillReceiveProps";
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") {
    foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
  }
  if (typeof prototype.componentWillUpdate === "function") {
    foundWillUpdateName = "componentWillUpdate";
  } else if (typeof prototype.UNSAFE_componentWillUpdate === "function") {
    foundWillUpdateName = "UNSAFE_componentWillUpdate";
  }
  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component.displayName || Component.name;
    var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      "Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks"
    );
  }
  if (typeof Component.getDerivedStateFromProps === "function") {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }
  if (typeof prototype.getSnapshotBeforeUpdate === "function") {
    if (typeof prototype.componentDidUpdate !== "function") {
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    }
    prototype.componentWillUpdate = componentWillUpdate;
    var componentDidUpdate = prototype.componentDidUpdate;
    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }
  return Component;
}
const reactLifecyclesCompat_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill
}, Symbol.toStringTag, { value: "Module" }));
const require$$6 = /* @__PURE__ */ getAugmentedNamespace(reactLifecyclesCompat_es);
var portalClassName_1;
Object.defineProperty(Modal$3, "__esModule", {
  value: true
});
var bodyOpenClassName_1 = Modal$3.bodyOpenClassName = portalClassName_1 = Modal$3.portalClassName = void 0;
var _extends$1 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = /* @__PURE__ */ function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = React__default;
var _react2 = _interopRequireDefault(_react);
var _reactDom = require$$1;
var _reactDom2 = _interopRequireDefault(_reactDom);
var _propTypes = require$$2$1;
var _propTypes2 = _interopRequireDefault(_propTypes);
var _ModalPortal = require$$3;
var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
var _ariaAppHider = require$$4;
var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
var _safeHTMLElement = require$$5$1;
var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
var _reactLifecyclesCompat = require$$6;
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var portalClassName = portalClassName_1 = Modal$3.portalClassName = "ReactModalPortal";
var bodyOpenClassName = bodyOpenClassName_1 = Modal$3.bodyOpenClassName = "ReactModal__Body--open";
var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== void 0;
var createHTMLElement = function createHTMLElement2(name) {
  return document.createElement(name);
};
var getCreatePortal = function getCreatePortal2() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function getParentElement(parentSelector2) {
  return parentSelector2();
}
var Modal$1 = function(_Component) {
  _inherits(Modal2, _Component);
  function Modal2() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, Modal2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal2.__proto__ || Object.getPrototypeOf(Modal2)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function() {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
      }
    }, _this.portalRef = function(ref) {
      _this.portal = ref;
    }, _this.renderPortal = function(props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends$1({ defaultStyles: Modal2.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Modal2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;
      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;
      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);
      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent, nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props, isOpen = _props.isOpen, portalClassName2 = _props.portalClassName;
      if (prevProps.portalClassName !== portalClassName2) {
        this.node.className = portalClassName2;
      }
      var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }
      if (!prevProps.isOpen && !isOpen) return;
      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }
        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }
      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }
      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends$1({
        ref: this.portalRef,
        defaultStyles: Modal2.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }
    /* eslint-disable react/no-unused-prop-types */
    /* eslint-enable react/no-unused-prop-types */
  }]);
  return Modal2;
}(_react.Component);
Modal$1.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal$1.defaultProps = {
  isOpen: false,
  portalClassName,
  bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal$1.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, _reactLifecyclesCompat.polyfill)(Modal$1);
if (process.env.NODE_ENV !== "production") {
  Modal$1.setCreateHTMLElement = function(fn) {
    return createHTMLElement = fn;
  };
}
var _default = Modal$3.default = Modal$1;
const Modal$2 = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  get bodyOpenClassName() {
    return bodyOpenClassName_1;
  },
  default: _default,
  get portalClassName() {
    return portalClassName_1;
  }
}, [Modal$3]);
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(Modal$2);
(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _Modal = require$$0;
  var _Modal2 = _interopRequireDefault2(_Modal);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  exports.default = _Modal2.default;
  module.exports = exports["default"];
})(lib, lib.exports);
var libExports = lib.exports;
const Modal = /* @__PURE__ */ getDefaultExportFromCjs(libExports);
function CommonModal(_a) {
  var { children, style = { content: {}, overlay: {} } } = _a, props = __rest(_a, ["children", "style"]);
  const contentStyle = Object.assign({ backgroundColor: "rgb(12, 12, 14)", borderRadius: "14px" }, style.content);
  const overlayStyle = Object.assign({ backdropFilter: "blur(2px)", backgroundColor: "transparent" }, style.overlay);
  return jsxRuntimeExports.jsx(Modal, Object.assign({ shouldCloseOnOverlayClick: true, style: { content: contentStyle, overlay: overlayStyle }, ariaHideApp: true }, props, { children }));
}
function CompareFilesModal() {
  const classPrefix = "compare-files-modal";
  const { fileList, compareFiles } = useSupabase();
  const { isCompareFilesModalShow, setIsCompareFilesModalShow, bidContactDocumentName, specificationDocumentName, setIsFilesModalShow, setSelectFileType, currentChatroom, setFiles, setToastInfo, setBidContactDocumentName, setSpecificationDocumentName } = useChatroom();
  const onCloseFilesCompare = () => {
    setBidContactDocumentName("");
    setSpecificationDocumentName("");
    setIsCompareFilesModalShow(false);
  };
  const onOpenFilesModal = (type) => {
    return () => {
      setIsFilesModalShow(true);
      setSelectFileType(type);
    };
  };
  const getFiles = () => __awaiter(this, void 0, void 0, function* () {
    try {
      if (!(currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.room_id))
        return;
      const _files = (yield fileList(currentChatroom.room_id)).map((_) => Object.assign(Object.assign({}, _), { isChecked: false, isHide: false, isSetting: false }));
      setFiles(_files);
    } catch (error) {
      setToastInfo({ type: "error", message: error.message });
    }
  });
  const onStartCompare = () => __awaiter(this, void 0, void 0, function* () {
    if (!(currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.room_id))
      return;
    try {
      yield compareFiles(bidContactDocumentName, specificationDocumentName, currentChatroom.room_id);
      setToastInfo({ type: "success", message: "Compare Successfully." });
      setIsCompareFilesModalShow(false);
      setBidContactDocumentName("");
      setSpecificationDocumentName("");
      const files = (yield fileList(currentChatroom.room_id)).map((_) => Object.assign(Object.assign({}, _), { isChecked: false, isHide: false, isSetting: false }));
      setFiles(files);
    } catch (error) {
      setToastInfo({ type: "error", message: error.message });
    }
  });
  useEffect(() => {
    if (isCompareFilesModalShow) {
      getFiles();
    }
  }, [isCompareFilesModalShow]);
  return jsxRuntimeExports.jsx(CommonModal, { style: {
    overlay: {
      zIndex: 100
    },
    content: {
      zIndex: 1e3,
      height: "100%",
      width: "100%",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      border: "none",
      borderRadius: "0"
    }
  }, onRequestClose: onCloseFilesCompare, isOpen: isCompareFilesModalShow, ariaHideApp: false, children: jsxRuntimeExports.jsxs("section", { className: `${classPrefix}`, children: [jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-header`, children: [jsxRuntimeExports.jsx("span", { children: "Intelligent Document Analysis" }), jsxRuntimeExports.jsx("button", { onClick: onCloseFilesCompare, children: jsxRuntimeExports.jsx(CloseSVG, {}) })] }), jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-bot`, children: [jsxRuntimeExports.jsx(DallmLogo, { className: "logo" }), jsxRuntimeExports.jsx("p", { children: "Hello, how can I help you?" })] }), jsxRuntimeExports.jsxs("ul", { className: `${classPrefix}-document`, children: [jsxRuntimeExports.jsx("li", { children: jsxRuntimeExports.jsxs("button", { onClick: onOpenFilesModal("bid"), children: [jsxRuntimeExports.jsx(NullFileSVG, {}), jsxRuntimeExports.jsxs("h5", { children: ["Choose the bid contact document", !!bidContactDocumentName && jsxRuntimeExports.jsxs("span", { className: "font-medium text-primary", children: ["/", bidContactDocumentName] })] }), jsxRuntimeExports.jsx("p", { children: "Can support,pdf,doc,docx,xls,ppt format file upload a single file" })] }) }), jsxRuntimeExports.jsx("li", { children: jsxRuntimeExports.jsxs("button", { onClick: onOpenFilesModal("spec"), children: [jsxRuntimeExports.jsx(HasFileSVG, {}), jsxRuntimeExports.jsxs("h5", { children: ["Choose specification document", !!specificationDocumentName && jsxRuntimeExports.jsxs("span", { className: "font-medium text-primary", children: ["/", specificationDocumentName] })] }), jsxRuntimeExports.jsx("p", { children: "Can support,pdf,doc,docx,xls,ppt format file upload a single file" })] }) })] }), jsxRuntimeExports.jsx("div", { className: `${classPrefix}-start`, children: bidContactDocumentName && specificationDocumentName && jsxRuntimeExports.jsx("button", { onClick: onStartCompare, children: "Start Compare" }) })] }) });
}
const usePreview = () => {
  const [preview, setPreview] = useState(null);
  useEffect(() => {
    return () => {
      preview && URL.revokeObjectURL(preview);
    };
  }, [preview]);
  const getPreview = (file) => {
    if (!file) {
      setPreview(null);
      return;
    }
    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
  };
  return [preview, getPreview];
};
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) ;
      else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function useEvent(callback) {
  var fnRef = React.useRef();
  fnRef.current = callback;
  var memoFn = React.useCallback(function() {
    var _fnRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
  }, []);
  return memoFn;
}
function canUseDom() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var useInternalLayoutEffect = process.env.NODE_ENV !== "test" && canUseDom() ? React.useLayoutEffect : React.useEffect;
var useLayoutEffect = function useLayoutEffect2(callback, deps) {
  var firstMountRef = React.useRef(true);
  useInternalLayoutEffect(function() {
    return callback(firstMountRef.current);
  }, deps);
  useInternalLayoutEffect(function() {
    firstMountRef.current = false;
    return function() {
      firstMountRef.current = true;
    };
  }, []);
};
var useLayoutUpdateEffect = function useLayoutUpdateEffect2(callback, deps) {
  useLayoutEffect(function(firstMount) {
    if (!firstMount) {
      return callback();
    }
  }, deps);
};
function useSafeState(defaultValue) {
  var destroyRef = React.useRef(false);
  var _React$useState = React.useState(defaultValue), _React$useState2 = _slicedToArray(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
  React.useEffect(function() {
    destroyRef.current = false;
    return function() {
      destroyRef.current = true;
    };
  }, []);
  function safeSetState(updater, ignoreDestroy) {
    if (ignoreDestroy && destroyRef.current) {
      return;
    }
    setValue(updater);
  }
  return [value, safeSetState];
}
function hasValue(value) {
  return value !== void 0;
}
function useMergedState(defaultStateValue, option) {
  var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
  var _useState = useSafeState(function() {
    if (hasValue(value)) {
      return value;
    } else if (hasValue(defaultValue)) {
      return typeof defaultValue === "function" ? defaultValue() : defaultValue;
    } else {
      return defaultStateValue;
    }
  }), _useState2 = _slicedToArray(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
  var mergedValue = value !== void 0 ? value : innerValue;
  var postMergedValue = postState ? postState(mergedValue) : mergedValue;
  var onChangeFn = useEvent(onChange);
  var _useState3 = useSafeState([mergedValue]), _useState4 = _slicedToArray(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
  useLayoutUpdateEffect(function() {
    var prev = prevValue[0];
    if (innerValue !== prev) {
      onChangeFn(innerValue, prev);
    }
  }, [prevValue]);
  useLayoutUpdateEffect(function() {
    if (!hasValue(value)) {
      setInnerValue(value);
    }
  }, [value]);
  var triggerChange = useEvent(function(updater, ignoreDestroy) {
    setInnerValue(updater, ignoreDestroy);
    setPrevValue([mergedValue], ignoreDestroy);
  });
  return [postMergedValue, triggerChange];
}
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;
    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    }
    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;
      default:
        return true;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }
    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }
    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    }
    if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) {
      return true;
    }
    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;
      default:
        return false;
    }
  }
};
var _excluded = ["prefixCls", "className", "checked", "defaultChecked", "disabled", "loadingIcon", "checkedChildren", "unCheckedChildren", "onClick", "onChange", "onKeyDown"];
var Switch = /* @__PURE__ */ React.forwardRef(function(_ref, ref) {
  var _classNames;
  var _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-switch" : _ref$prefixCls, className = _ref.className, checked = _ref.checked, defaultChecked = _ref.defaultChecked, disabled = _ref.disabled, loadingIcon = _ref.loadingIcon, checkedChildren = _ref.checkedChildren, unCheckedChildren = _ref.unCheckedChildren, onClick = _ref.onClick, onChange = _ref.onChange, onKeyDown = _ref.onKeyDown, restProps = _objectWithoutProperties(_ref, _excluded);
  var _useMergedState = useMergedState(false, {
    value: checked,
    defaultValue: defaultChecked
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), innerChecked = _useMergedState2[0], setInnerChecked = _useMergedState2[1];
  function triggerChange(newChecked, event) {
    var mergedChecked = innerChecked;
    if (!disabled) {
      mergedChecked = newChecked;
      setInnerChecked(mergedChecked);
      onChange === null || onChange === void 0 ? void 0 : onChange(mergedChecked, event);
    }
    return mergedChecked;
  }
  function onInternalKeyDown(e) {
    if (e.which === KeyCode.LEFT) {
      triggerChange(false, e);
    } else if (e.which === KeyCode.RIGHT) {
      triggerChange(true, e);
    }
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
  }
  function onInternalClick(e) {
    var ret = triggerChange(!innerChecked, e);
    onClick === null || onClick === void 0 ? void 0 : onClick(ret, e);
  }
  var switchClassName = classNames(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-checked"), innerChecked), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
  return /* @__PURE__ */ React.createElement("button", _extends({}, restProps, {
    type: "button",
    role: "switch",
    "aria-checked": innerChecked,
    disabled,
    className: switchClassName,
    ref,
    onKeyDown: onInternalKeyDown,
    onClick: onInternalClick
  }), loadingIcon, /* @__PURE__ */ React.createElement("span", {
    className: "".concat(prefixCls, "-inner")
  }, /* @__PURE__ */ React.createElement("span", {
    className: "".concat(prefixCls, "-inner-checked")
  }, checkedChildren), /* @__PURE__ */ React.createElement("span", {
    className: "".concat(prefixCls, "-inner-unchecked")
  }, unCheckedChildren)));
});
Switch.displayName = "Switch";
var isCheckBoxInput = (element) => element.type === "checkbox";
var isDateObject = (value) => value instanceof Date;
var isNullOrUndefined = (value) => value == null;
const isObjectType = (value) => typeof value === "object";
var isObject = (value) => !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !isDateObject(value);
var getEventValue = (event) => isObject(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));
var isPlainObject = (tempObject) => {
  const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
  return isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function cloneObject(data) {
  let copy;
  const isArray = Array.isArray(data);
  if (data instanceof Date) {
    copy = new Date(data);
  } else if (data instanceof Set) {
    copy = new Set(data);
  } else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || isObject(data))) {
    copy = isArray ? [] : {};
    if (!isArray && !isPlainObject(data)) {
      copy = data;
    } else {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          copy[key] = cloneObject(data[key]);
        }
      }
    }
  } else {
    return data;
  }
  return copy;
}
var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];
var isUndefined = (val) => val === void 0;
var get = (object, path, defaultValue) => {
  if (!path || !isObject(object)) {
    return defaultValue;
  }
  const result = compact(path.split(/[,[\].]+?/)).reduce((result2, key) => isNullOrUndefined(result2) ? result2 : result2[key], object);
  return isUndefined(result) || result === object ? isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var isBoolean = (value) => typeof value === "boolean";
var isKey = (value) => /^\w*$/.test(value);
var stringToPath = (input) => compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var set = (object, path, value) => {
  let index2 = -1;
  const tempPath = isKey(path) ? [path] : stringToPath(path);
  const length = tempPath.length;
  const lastIndex = length - 1;
  while (++index2 < length) {
    const key = tempPath[index2];
    let newValue = value;
    if (index2 !== lastIndex) {
      const objValue = object[key];
      newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index2 + 1]) ? [] : {};
    }
    if (key === "__proto__") {
      return;
    }
    object[key] = newValue;
    object = object[key];
  }
  return object;
};
const EVENTS = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
};
const VALIDATION_MODE = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
};
const INPUT_VALIDATION_RULES = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
};
React__default.createContext(null);
var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
  const result = {
    defaultValues: control._defaultValues
  };
  for (const key in formState) {
    Object.defineProperty(result, key, {
      get: () => {
        const _key = key;
        if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
          control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
        }
        return formState[_key];
      }
    });
  }
  return result;
};
var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;
var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
  updateFormState(formStateData);
  const { name, ...formState } = formStateData;
  return isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key) => _proxyFormState[key] === VALIDATION_MODE.all);
};
var convertToArrayPayload = (value) => Array.isArray(value) ? value : [value];
function useSubscribe(props) {
  const _props = React__default.useRef(props);
  _props.current = props;
  React__default.useEffect(() => {
    const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
      next: _props.current.next
    });
    return () => {
      subscription && subscription.unsubscribe();
    };
  }, [props.disabled]);
}
var isString = (value) => typeof value === "string";
var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
  if (isString(names)) {
    isGlobal && _names.watch.add(names);
    return get(formValues, names, defaultValue);
  }
  if (Array.isArray(names)) {
    return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
  }
  isGlobal && (_names.watchAll = true);
  return formValues;
};
var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria ? {
  ...errors[name],
  types: {
    ...errors[name] && errors[name].types ? errors[name].types : {},
    [type]: message || true
  }
} : {};
var getValidationModes = (mode) => ({
  isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
  isOnBlur: mode === VALIDATION_MODE.onBlur,
  isOnChange: mode === VALIDATION_MODE.onChange,
  isOnAll: mode === VALIDATION_MODE.all,
  isOnTouch: mode === VALIDATION_MODE.onTouched
});
var isWatched = (name, _names, isBlurEvent) => !isBlurEvent && (_names.watchAll || _names.watch.has(name) || [..._names.watch].some((watchName) => name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const iterateFieldsByAction = (fields, action, fieldsNames, abortEarly) => {
  for (const key of fieldsNames || Object.keys(fields)) {
    const field = get(fields, key);
    if (field) {
      const { _f, ...currentField } = field;
      if (_f) {
        if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) {
          break;
        } else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) {
          break;
        } else {
          iterateFieldsByAction(currentField, action);
        }
      } else if (isObject(currentField)) {
        iterateFieldsByAction(currentField, action);
      }
    }
  }
};
var updateFieldArrayRootError = (errors, error, name) => {
  const fieldArrayErrors = compact(get(errors, name));
  set(fieldArrayErrors, "root", error[name]);
  set(errors, name, fieldArrayErrors);
  return errors;
};
var isFileInput = (element) => element.type === "file";
var isFunction = (value) => typeof value === "function";
var isHTMLElement = (value) => {
  if (!isWeb) {
    return false;
  }
  const owner = value ? value.ownerDocument : 0;
  return value instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var isMessage = (value) => isString(value);
var isRadioInput = (element) => element.type === "radio";
var isRegex = (value) => value instanceof RegExp;
const defaultResult = {
  value: false,
  isValid: false
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
  if (Array.isArray(options)) {
    if (options.length > 1) {
      const values = options.filter((option) => option && option.checked && !option.disabled).map((option) => option.value);
      return { value: values, isValid: !!values.length };
    }
    return options[0].checked && !options[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      options[0].attributes && !isUndefined(options[0].attributes.value) ? isUndefined(options[0].value) || options[0].value === "" ? validResult : { value: options[0].value, isValid: true } : validResult
    ) : defaultResult;
  }
  return defaultResult;
};
const defaultReturn = {
  isValid: false,
  value: null
};
var getRadioValue = (options) => Array.isArray(options) ? options.reduce((previous, option) => option && option.checked && !option.disabled ? {
  isValid: true,
  value: option.value
} : previous, defaultReturn) : defaultReturn;
function getValidateError(result, ref, type = "validate") {
  if (isMessage(result) || Array.isArray(result) && result.every(isMessage) || isBoolean(result) && !result) {
    return {
      type,
      message: isMessage(result) ? result : "",
      ref
    };
  }
}
var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData) ? validationData : {
  value: validationData,
  message: ""
};
var validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
  const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled } = field._f;
  const inputValue = get(formValues, name);
  if (!mount || disabled) {
    return {};
  }
  const inputRef = refs ? refs[0] : ref;
  const setCustomValidity = (message) => {
    if (shouldUseNativeValidation && inputRef.reportValidity) {
      inputRef.setCustomValidity(isBoolean(message) ? "" : message || "");
      inputRef.reportValidity();
    }
  };
  const error = {};
  const isRadio = isRadioInput(ref);
  const isCheckBox = isCheckBoxInput(ref);
  const isRadioOrCheckbox2 = isRadio || isCheckBox;
  const isEmpty = (valueAsNumber || isFileInput(ref)) && isUndefined(ref.value) && isUndefined(inputValue) || isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
  const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
  const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
    const message = exceedMax ? maxLengthMessage : minLengthMessage;
    error[name] = {
      type: exceedMax ? maxType : minType,
      message,
      ref,
      ...appendErrorsCurry(exceedMax ? maxType : minType, message)
    };
  };
  if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox2 && (isEmpty || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid)) {
    const { value, message } = isMessage(required) ? { value: !!required, message: required } : getValueAndMessage(required);
    if (value) {
      error[name] = {
        type: INPUT_VALIDATION_RULES.required,
        message,
        ref: inputRef,
        ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message)
      };
      if (!validateAllFieldCriteria) {
        setCustomValidity(message);
        return error;
      }
    }
  }
  if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
    let exceedMax;
    let exceedMin;
    const maxOutput = getValueAndMessage(max);
    const minOutput = getValueAndMessage(min);
    if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
      const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
      if (!isNullOrUndefined(maxOutput.value)) {
        exceedMax = valueNumber > maxOutput.value;
      }
      if (!isNullOrUndefined(minOutput.value)) {
        exceedMin = valueNumber < minOutput.value;
      }
    } else {
      const valueDate = ref.valueAsDate || new Date(inputValue);
      const convertTimeToDate = (time) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + time);
      const isTime = ref.type == "time";
      const isWeek = ref.type == "week";
      if (isString(maxOutput.value) && inputValue) {
        exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
      }
      if (isString(minOutput.value) && inputValue) {
        exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
      }
    }
    if (exceedMax || exceedMin) {
      getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
      if (!validateAllFieldCriteria) {
        setCustomValidity(error[name].message);
        return error;
      }
    }
  }
  if ((maxLength || minLength) && !isEmpty && (isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
    const maxLengthOutput = getValueAndMessage(maxLength);
    const minLengthOutput = getValueAndMessage(minLength);
    const exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
    const exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
    if (exceedMax || exceedMin) {
      getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
      if (!validateAllFieldCriteria) {
        setCustomValidity(error[name].message);
        return error;
      }
    }
  }
  if (pattern && !isEmpty && isString(inputValue)) {
    const { value: patternValue, message } = getValueAndMessage(pattern);
    if (isRegex(patternValue) && !inputValue.match(patternValue)) {
      error[name] = {
        type: INPUT_VALIDATION_RULES.pattern,
        message,
        ref,
        ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message)
      };
      if (!validateAllFieldCriteria) {
        setCustomValidity(message);
        return error;
      }
    }
  }
  if (validate) {
    if (isFunction(validate)) {
      const result = await validate(inputValue, formValues);
      const validateError = getValidateError(result, inputRef);
      if (validateError) {
        error[name] = {
          ...validateError,
          ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message)
        };
        if (!validateAllFieldCriteria) {
          setCustomValidity(validateError.message);
          return error;
        }
      }
    } else if (isObject(validate)) {
      let validationResult = {};
      for (const key in validate) {
        if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
          break;
        }
        const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
        if (validateError) {
          validationResult = {
            ...validateError,
            ...appendErrorsCurry(key, validateError.message)
          };
          setCustomValidity(validateError.message);
          if (validateAllFieldCriteria) {
            error[name] = validationResult;
          }
        }
      }
      if (!isEmptyObject(validationResult)) {
        error[name] = {
          ref: inputRef,
          ...validationResult
        };
        if (!validateAllFieldCriteria) {
          return error;
        }
      }
    }
  }
  setCustomValidity(true);
  return error;
};
function baseGet(object, updatePath) {
  const length = updatePath.slice(0, -1).length;
  let index2 = 0;
  while (index2 < length) {
    object = isUndefined(object) ? index2++ : object[updatePath[index2++]];
  }
  return object;
}
function isEmptyArray(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) {
      return false;
    }
  }
  return true;
}
function unset(object, path) {
  const paths = Array.isArray(path) ? path : isKey(path) ? [path] : stringToPath(path);
  const childObject = paths.length === 1 ? object : baseGet(object, paths);
  const index2 = paths.length - 1;
  const key = paths[index2];
  if (childObject) {
    delete childObject[key];
  }
  if (index2 !== 0 && (isObject(childObject) && isEmptyObject(childObject) || Array.isArray(childObject) && isEmptyArray(childObject))) {
    unset(object, paths.slice(0, -1));
  }
  return object;
}
var createSubject = () => {
  let _observers = [];
  const next = (value) => {
    for (const observer of _observers) {
      observer.next && observer.next(value);
    }
  };
  const subscribe = (observer) => {
    _observers.push(observer);
    return {
      unsubscribe: () => {
        _observers = _observers.filter((o) => o !== observer);
      }
    };
  };
  const unsubscribe = () => {
    _observers = [];
  };
  return {
    get observers() {
      return _observers;
    },
    next,
    subscribe,
    unsubscribe
  };
};
var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);
function deepEqual(object1, object2) {
  if (isPrimitive(object1) || isPrimitive(object2)) {
    return object1 === object2;
  }
  if (isDateObject(object1) && isDateObject(object2)) {
    return object1.getTime() === object2.getTime();
  }
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    const val1 = object1[key];
    if (!keys2.includes(key)) {
      return false;
    }
    if (key !== "ref") {
      const val2 = object2[key];
      if (isDateObject(val1) && isDateObject(val2) || isObject(val1) && isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !deepEqual(val1, val2) : val1 !== val2) {
        return false;
      }
    }
  }
  return true;
}
var isMultipleSelect = (element) => element.type === `select-multiple`;
var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);
var live = (ref) => isHTMLElement(ref) && ref.isConnected;
var objectHasFunction = (data) => {
  for (const key in data) {
    if (isFunction(data[key])) {
      return true;
    }
  }
  return false;
};
function markFieldsDirty(data, fields = {}) {
  const isParentNodeArray = Array.isArray(data);
  if (isObject(data) || isParentNodeArray) {
    for (const key in data) {
      if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
        fields[key] = Array.isArray(data[key]) ? [] : {};
        markFieldsDirty(data[key], fields[key]);
      } else if (!isNullOrUndefined(data[key])) {
        fields[key] = true;
      }
    }
  }
  return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
  const isParentNodeArray = Array.isArray(data);
  if (isObject(data) || isParentNodeArray) {
    for (const key in data) {
      if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
        if (isUndefined(formValues) || isPrimitive(dirtyFieldsFromValues[key])) {
          dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? markFieldsDirty(data[key], []) : { ...markFieldsDirty(data[key]) };
        } else {
          getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        }
      } else {
        dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
      }
    }
  }
  return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));
var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value) ? value : valueAsNumber ? value === "" ? NaN : value ? +value : value : valueAsDate && isString(value) ? new Date(value) : setValueAs ? setValueAs(value) : value;
function getFieldValue(_f) {
  const ref = _f.ref;
  if (_f.refs ? _f.refs.every((ref2) => ref2.disabled) : ref.disabled) {
    return;
  }
  if (isFileInput(ref)) {
    return ref.files;
  }
  if (isRadioInput(ref)) {
    return getRadioValue(_f.refs).value;
  }
  if (isMultipleSelect(ref)) {
    return [...ref.selectedOptions].map(({ value }) => value);
  }
  if (isCheckBoxInput(ref)) {
    return getCheckboxValue(_f.refs).value;
  }
  return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
  const fields = {};
  for (const name of fieldsNames) {
    const field = get(_fields, name);
    field && set(fields, name, field._f);
  }
  return {
    criteriaMode,
    names: [...fieldsNames],
    fields,
    shouldUseNativeValidation
  };
};
var getRuleValue = (rule) => isUndefined(rule) ? rule : isRegex(rule) ? rule.source : isObject(rule) ? isRegex(rule.value) ? rule.value.source : rule.value : rule;
var hasValidation = (options) => options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function schemaErrorLookup(errors, _fields, name) {
  const error = get(errors, name);
  if (error || isKey(name)) {
    return {
      error,
      name
    };
  }
  const names = name.split(".");
  while (names.length) {
    const fieldName = names.join(".");
    const field = get(_fields, fieldName);
    const foundError = get(errors, fieldName);
    if (field && !Array.isArray(field) && name !== fieldName) {
      return { name };
    }
    if (foundError && foundError.type) {
      return {
        name: fieldName,
        error: foundError
      };
    }
    names.pop();
  }
  return {
    name
  };
}
var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
  if (mode.isOnAll) {
    return false;
  } else if (!isSubmitted && mode.isOnTouch) {
    return !(isTouched || isBlurEvent);
  } else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
    return !isBlurEvent;
  } else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
    return isBlurEvent;
  }
  return true;
};
var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);
const defaultOptions = {
  mode: VALIDATION_MODE.onSubmit,
  reValidateMode: VALIDATION_MODE.onChange,
  shouldFocusError: true
};
function createFormControl(props = {}) {
  let _options = {
    ...defaultOptions,
    ...props
  };
  let _formState = {
    submitCount: 0,
    isDirty: false,
    isLoading: isFunction(_options.defaultValues),
    isValidating: false,
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: _options.errors || {},
    disabled: _options.disabled || false
  };
  let _fields = {};
  let _defaultValues = isObject(_options.defaultValues) || isObject(_options.values) ? cloneObject(_options.defaultValues || _options.values) || {} : {};
  let _formValues = _options.shouldUnregister ? {} : cloneObject(_defaultValues);
  let _state = {
    action: false,
    mount: false,
    watch: false
  };
  let _names = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  };
  let delayErrorCallback;
  let timer = 0;
  const _proxyFormState = {
    isDirty: false,
    dirtyFields: false,
    validatingFields: false,
    touchedFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  };
  const _subjects = {
    values: createSubject(),
    array: createSubject(),
    state: createSubject()
  };
  const validationModeBeforeSubmit = getValidationModes(_options.mode);
  const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
  const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
  const debounce = (callback) => (wait) => {
    clearTimeout(timer);
    timer = setTimeout(callback, wait);
  };
  const _updateValid = async (shouldUpdateValid) => {
    if (_proxyFormState.isValid || shouldUpdateValid) {
      const isValid = _options.resolver ? isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
      if (isValid !== _formState.isValid) {
        _subjects.state.next({
          isValid
        });
      }
    }
  };
  const _updateIsValidating = (names, isValidating) => {
    if (_proxyFormState.isValidating || _proxyFormState.validatingFields) {
      (names || Array.from(_names.mount)).forEach((name) => {
        if (name) {
          isValidating ? set(_formState.validatingFields, name, isValidating) : unset(_formState.validatingFields, name);
        }
      });
      _subjects.state.next({
        validatingFields: _formState.validatingFields,
        isValidating: !isEmptyObject(_formState.validatingFields)
      });
    }
  };
  const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
    if (args && method) {
      _state.action = true;
      if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
        const fieldValues = method(get(_fields, name), args.argA, args.argB);
        shouldSetValues && set(_fields, name, fieldValues);
      }
      if (shouldUpdateFieldsAndState && Array.isArray(get(_formState.errors, name))) {
        const errors = method(get(_formState.errors, name), args.argA, args.argB);
        shouldSetValues && set(_formState.errors, name, errors);
        unsetEmptyArray(_formState.errors, name);
      }
      if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray(get(_formState.touchedFields, name))) {
        const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
        shouldSetValues && set(_formState.touchedFields, name, touchedFields);
      }
      if (_proxyFormState.dirtyFields) {
        _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
      }
      _subjects.state.next({
        name,
        isDirty: _getDirty(name, values),
        dirtyFields: _formState.dirtyFields,
        errors: _formState.errors,
        isValid: _formState.isValid
      });
    } else {
      set(_formValues, name, values);
    }
  };
  const updateErrors = (name, error) => {
    set(_formState.errors, name, error);
    _subjects.state.next({
      errors: _formState.errors
    });
  };
  const _setErrors = (errors) => {
    _formState.errors = errors;
    _subjects.state.next({
      errors: _formState.errors,
      isValid: false
    });
  };
  const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
    const field = get(_fields, name);
    if (field) {
      const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
      isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f)) : setFieldValue(name, defaultValue);
      _state.mount && _updateValid();
    }
  };
  const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
    let shouldUpdateField = false;
    let isPreviousDirty = false;
    const output = {
      name
    };
    const disabledField = !!(get(_fields, name) && get(_fields, name)._f && get(_fields, name)._f.disabled);
    if (!isBlurEvent || shouldDirty) {
      if (_proxyFormState.isDirty) {
        isPreviousDirty = _formState.isDirty;
        _formState.isDirty = output.isDirty = _getDirty();
        shouldUpdateField = isPreviousDirty !== output.isDirty;
      }
      const isCurrentFieldPristine = disabledField || deepEqual(get(_defaultValues, name), fieldValue);
      isPreviousDirty = !!(!disabledField && get(_formState.dirtyFields, name));
      isCurrentFieldPristine || disabledField ? unset(_formState.dirtyFields, name) : set(_formState.dirtyFields, name, true);
      output.dirtyFields = _formState.dirtyFields;
      shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
    }
    if (isBlurEvent) {
      const isPreviousFieldTouched = get(_formState.touchedFields, name);
      if (!isPreviousFieldTouched) {
        set(_formState.touchedFields, name, isBlurEvent);
        output.touchedFields = _formState.touchedFields;
        shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
      }
    }
    shouldUpdateField && shouldRender && _subjects.state.next(output);
    return shouldUpdateField ? output : {};
  };
  const shouldRenderByError = (name, isValid, error, fieldState) => {
    const previousFieldError = get(_formState.errors, name);
    const shouldUpdateValid = _proxyFormState.isValid && isBoolean(isValid) && _formState.isValid !== isValid;
    if (props.delayError && error) {
      delayErrorCallback = debounce(() => updateErrors(name, error));
      delayErrorCallback(props.delayError);
    } else {
      clearTimeout(timer);
      delayErrorCallback = null;
      error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
    }
    if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) || !isEmptyObject(fieldState) || shouldUpdateValid) {
      const updatedFormState = {
        ...fieldState,
        ...shouldUpdateValid && isBoolean(isValid) ? { isValid } : {},
        errors: _formState.errors,
        name
      };
      _formState = {
        ..._formState,
        ...updatedFormState
      };
      _subjects.state.next(updatedFormState);
    }
  };
  const _executeSchema = async (name) => {
    _updateIsValidating(name, true);
    const result = await _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    _updateIsValidating(name);
    return result;
  };
  const executeSchemaAndUpdateState = async (names) => {
    const { errors } = await _executeSchema(names);
    if (names) {
      for (const name of names) {
        const error = get(errors, name);
        error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
      }
    } else {
      _formState.errors = errors;
    }
    return errors;
  };
  const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
    valid: true
  }) => {
    for (const name in fields) {
      const field = fields[name];
      if (field) {
        const { _f, ...fieldValue } = field;
        if (_f) {
          const isFieldArrayRoot = _names.array.has(_f.name);
          _updateIsValidating([name], true);
          const fieldError = await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
          _updateIsValidating([name]);
          if (fieldError[_f.name]) {
            context.valid = false;
            if (shouldOnlyCheckValid) {
              break;
            }
          }
          !shouldOnlyCheckValid && (get(fieldError, _f.name) ? isFieldArrayRoot ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : set(_formState.errors, _f.name, fieldError[_f.name]) : unset(_formState.errors, _f.name));
        }
        fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
      }
    }
    return context.valid;
  };
  const _removeUnmounted = () => {
    for (const name of _names.unMount) {
      const field = get(_fields, name);
      field && (field._f.refs ? field._f.refs.every((ref) => !live(ref)) : !live(field._f.ref)) && unregister(name);
    }
    _names.unMount = /* @__PURE__ */ new Set();
  };
  const _getDirty = (name, data) => (name && data && set(_formValues, name, data), !deepEqual(getValues(), _defaultValues));
  const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
    ..._state.mount ? _formValues : isUndefined(defaultValue) ? _defaultValues : isString(names) ? { [names]: defaultValue } : defaultValue
  }, isGlobal, defaultValue);
  const _getFieldArray = (name) => compact(get(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
  const setFieldValue = (name, value, options = {}) => {
    const field = get(_fields, name);
    let fieldValue = value;
    if (field) {
      const fieldReference = field._f;
      if (fieldReference) {
        !fieldReference.disabled && set(_formValues, name, getFieldValueAs(value, fieldReference));
        fieldValue = isHTMLElement(fieldReference.ref) && isNullOrUndefined(value) ? "" : value;
        if (isMultipleSelect(fieldReference.ref)) {
          [...fieldReference.ref.options].forEach((optionRef) => optionRef.selected = fieldValue.includes(optionRef.value));
        } else if (fieldReference.refs) {
          if (isCheckBoxInput(fieldReference.ref)) {
            fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef) => (!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data) => data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
          } else {
            fieldReference.refs.forEach((radioRef) => radioRef.checked = radioRef.value === fieldValue);
          }
        } else if (isFileInput(fieldReference.ref)) {
          fieldReference.ref.value = "";
        } else {
          fieldReference.ref.value = fieldValue;
          if (!fieldReference.ref.type) {
            _subjects.values.next({
              name,
              values: { ..._formValues }
            });
          }
        }
      }
    }
    (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
    options.shouldValidate && trigger(name);
  };
  const setValues = (name, value, options) => {
    for (const fieldKey in value) {
      const fieldValue = value[fieldKey];
      const fieldName = `${name}.${fieldKey}`;
      const field = get(_fields, fieldName);
      (_names.array.has(name) || !isPrimitive(fieldValue) || field && !field._f) && !isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
    }
  };
  const setValue = (name, value, options = {}) => {
    const field = get(_fields, name);
    const isFieldArray = _names.array.has(name);
    const cloneValue = cloneObject(value);
    set(_formValues, name, cloneValue);
    if (isFieldArray) {
      _subjects.array.next({
        name,
        values: { ..._formValues }
      });
      if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) {
        _subjects.state.next({
          name,
          dirtyFields: getDirtyFields(_defaultValues, _formValues),
          isDirty: _getDirty(name, cloneValue)
        });
      }
    } else {
      field && !field._f && !isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
    }
    isWatched(name, _names) && _subjects.state.next({ ..._formState });
    _subjects.values.next({
      name: _state.mount ? name : void 0,
      values: { ..._formValues }
    });
  };
  const onChange = async (event) => {
    _state.mount = true;
    const target = event.target;
    let name = target.name;
    let isFieldValueUpdated = true;
    const field = get(_fields, name);
    const getCurrentFieldValue = () => target.type ? getFieldValue(field._f) : getEventValue(event);
    const _updateIsFieldValueUpdated = (fieldValue) => {
      isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === get(_formValues, name, fieldValue);
    };
    if (field) {
      let error;
      let isValid;
      const fieldValue = getCurrentFieldValue();
      const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
      const shouldSkipValidation = !hasValidation(field._f) && !_options.resolver && !get(_formState.errors, name) && !field._f.deps || skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
      const watched = isWatched(name, _names, isBlurEvent);
      set(_formValues, name, fieldValue);
      if (isBlurEvent) {
        field._f.onBlur && field._f.onBlur(event);
        delayErrorCallback && delayErrorCallback(0);
      } else if (field._f.onChange) {
        field._f.onChange(event);
      }
      const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
      const shouldRender = !isEmptyObject(fieldState) || watched;
      !isBlurEvent && _subjects.values.next({
        name,
        type: event.type,
        values: { ..._formValues }
      });
      if (shouldSkipValidation) {
        _proxyFormState.isValid && _updateValid();
        return shouldRender && _subjects.state.next({ name, ...watched ? {} : fieldState });
      }
      !isBlurEvent && watched && _subjects.state.next({ ..._formState });
      if (_options.resolver) {
        const { errors } = await _executeSchema([name]);
        _updateIsFieldValueUpdated(fieldValue);
        if (isFieldValueUpdated) {
          const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
          const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
          error = errorLookupResult.error;
          name = errorLookupResult.name;
          isValid = isEmptyObject(errors);
        }
      } else {
        _updateIsValidating([name], true);
        error = (await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
        _updateIsValidating([name]);
        _updateIsFieldValueUpdated(fieldValue);
        if (isFieldValueUpdated) {
          if (error) {
            isValid = false;
          } else if (_proxyFormState.isValid) {
            isValid = await executeBuiltInValidation(_fields, true);
          }
        }
      }
      if (isFieldValueUpdated) {
        field._f.deps && trigger(field._f.deps);
        shouldRenderByError(name, isValid, error, fieldState);
      }
    }
  };
  const _focusInput = (ref, key) => {
    if (get(_formState.errors, key) && ref.focus) {
      ref.focus();
      return 1;
    }
    return;
  };
  const trigger = async (name, options = {}) => {
    let isValid;
    let validationResult;
    const fieldNames = convertToArrayPayload(name);
    if (_options.resolver) {
      const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
      isValid = isEmptyObject(errors);
      validationResult = name ? !fieldNames.some((name2) => get(errors, name2)) : isValid;
    } else if (name) {
      validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
        const field = get(_fields, fieldName);
        return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
      }))).every(Boolean);
      !(!validationResult && !_formState.isValid) && _updateValid();
    } else {
      validationResult = isValid = await executeBuiltInValidation(_fields);
    }
    _subjects.state.next({
      ...!isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : { name },
      ..._options.resolver || !name ? { isValid } : {},
      errors: _formState.errors
    });
    options.shouldFocus && !validationResult && iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
    return validationResult;
  };
  const getValues = (fieldNames) => {
    const values = {
      ..._state.mount ? _formValues : _defaultValues
    };
    return isUndefined(fieldNames) ? values : isString(fieldNames) ? get(values, fieldNames) : fieldNames.map((name) => get(values, name));
  };
  const getFieldState = (name, formState) => ({
    invalid: !!get((formState || _formState).errors, name),
    isDirty: !!get((formState || _formState).dirtyFields, name),
    error: get((formState || _formState).errors, name),
    isValidating: !!get(_formState.validatingFields, name),
    isTouched: !!get((formState || _formState).touchedFields, name)
  });
  const clearErrors = (name) => {
    name && convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName));
    _subjects.state.next({
      errors: name ? _formState.errors : {}
    });
  };
  const setError = (name, error, options) => {
    const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
    const currentError = get(_formState.errors, name) || {};
    const { ref: currentRef, message, type, ...restOfErrorTree } = currentError;
    set(_formState.errors, name, {
      ...restOfErrorTree,
      ...error,
      ref
    });
    _subjects.state.next({
      name,
      errors: _formState.errors,
      isValid: false
    });
    options && options.shouldFocus && ref && ref.focus && ref.focus();
  };
  const watch = (name, defaultValue) => isFunction(name) ? _subjects.values.subscribe({
    next: (payload) => name(_getWatch(void 0, defaultValue), payload)
  }) : _getWatch(name, defaultValue, true);
  const unregister = (name, options = {}) => {
    for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
      _names.mount.delete(fieldName);
      _names.array.delete(fieldName);
      if (!options.keepValue) {
        unset(_fields, fieldName);
        unset(_formValues, fieldName);
      }
      !options.keepError && unset(_formState.errors, fieldName);
      !options.keepDirty && unset(_formState.dirtyFields, fieldName);
      !options.keepTouched && unset(_formState.touchedFields, fieldName);
      !options.keepIsValidating && unset(_formState.validatingFields, fieldName);
      !_options.shouldUnregister && !options.keepDefaultValue && unset(_defaultValues, fieldName);
    }
    _subjects.values.next({
      values: { ..._formValues }
    });
    _subjects.state.next({
      ..._formState,
      ...!options.keepDirty ? {} : { isDirty: _getDirty() }
    });
    !options.keepIsValid && _updateValid();
  };
  const _updateDisabledField = ({ disabled, name, field, fields, value }) => {
    if (isBoolean(disabled) && _state.mount || !!disabled) {
      const inputValue = disabled ? void 0 : isUndefined(value) ? getFieldValue(field ? field._f : get(fields, name)._f) : value;
      set(_formValues, name, inputValue);
      updateTouchAndDirty(name, inputValue, false, false, true);
    }
  };
  const register = (name, options = {}) => {
    let field = get(_fields, name);
    const disabledIsDefined = isBoolean(options.disabled);
    set(_fields, name, {
      ...field || {},
      _f: {
        ...field && field._f ? field._f : { ref: { name } },
        name,
        mount: true,
        ...options
      }
    });
    _names.mount.add(name);
    if (field) {
      _updateDisabledField({
        field,
        disabled: options.disabled,
        name,
        value: options.value
      });
    } else {
      updateValidAndValue(name, true, options.value);
    }
    return {
      ...disabledIsDefined ? { disabled: options.disabled } : {},
      ..._options.progressive ? {
        required: !!options.required,
        min: getRuleValue(options.min),
        max: getRuleValue(options.max),
        minLength: getRuleValue(options.minLength),
        maxLength: getRuleValue(options.maxLength),
        pattern: getRuleValue(options.pattern)
      } : {},
      name,
      onChange,
      onBlur: onChange,
      ref: (ref) => {
        if (ref) {
          register(name, options);
          field = get(_fields, name);
          const fieldRef = isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
          const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
          const refs = field._f.refs || [];
          if (radioOrCheckbox ? refs.find((option) => option === fieldRef) : fieldRef === field._f.ref) {
            return;
          }
          set(_fields, name, {
            _f: {
              ...field._f,
              ...radioOrCheckbox ? {
                refs: [
                  ...refs.filter(live),
                  fieldRef,
                  ...Array.isArray(get(_defaultValues, name)) ? [{}] : []
                ],
                ref: { type: fieldRef.type, name }
              } : { ref: fieldRef }
            }
          });
          updateValidAndValue(name, false, void 0, fieldRef);
        } else {
          field = get(_fields, name, {});
          if (field._f) {
            field._f.mount = false;
          }
          (_options.shouldUnregister || options.shouldUnregister) && !(isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
        }
      }
    };
  };
  const _focusError = () => _options.shouldFocusError && iterateFieldsByAction(_fields, _focusInput, _names.mount);
  const _disableForm = (disabled) => {
    if (isBoolean(disabled)) {
      _subjects.state.next({ disabled });
      iterateFieldsByAction(_fields, (ref, name) => {
        const currentField = get(_fields, name);
        if (currentField) {
          ref.disabled = currentField._f.disabled || disabled;
          if (Array.isArray(currentField._f.refs)) {
            currentField._f.refs.forEach((inputRef) => {
              inputRef.disabled = currentField._f.disabled || disabled;
            });
          }
        }
      }, 0, false);
    }
  };
  const handleSubmit = (onValid, onInvalid) => async (e) => {
    let onValidError = void 0;
    if (e) {
      e.preventDefault && e.preventDefault();
      e.persist && e.persist();
    }
    let fieldValues = cloneObject(_formValues);
    _subjects.state.next({
      isSubmitting: true
    });
    if (_options.resolver) {
      const { errors, values } = await _executeSchema();
      _formState.errors = errors;
      fieldValues = values;
    } else {
      await executeBuiltInValidation(_fields);
    }
    unset(_formState.errors, "root");
    if (isEmptyObject(_formState.errors)) {
      _subjects.state.next({
        errors: {}
      });
      try {
        await onValid(fieldValues, e);
      } catch (error) {
        onValidError = error;
      }
    } else {
      if (onInvalid) {
        await onInvalid({ ..._formState.errors }, e);
      }
      _focusError();
      setTimeout(_focusError);
    }
    _subjects.state.next({
      isSubmitted: true,
      isSubmitting: false,
      isSubmitSuccessful: isEmptyObject(_formState.errors) && !onValidError,
      submitCount: _formState.submitCount + 1,
      errors: _formState.errors
    });
    if (onValidError) {
      throw onValidError;
    }
  };
  const resetField = (name, options = {}) => {
    if (get(_fields, name)) {
      if (isUndefined(options.defaultValue)) {
        setValue(name, cloneObject(get(_defaultValues, name)));
      } else {
        setValue(name, options.defaultValue);
        set(_defaultValues, name, cloneObject(options.defaultValue));
      }
      if (!options.keepTouched) {
        unset(_formState.touchedFields, name);
      }
      if (!options.keepDirty) {
        unset(_formState.dirtyFields, name);
        _formState.isDirty = options.defaultValue ? _getDirty(name, cloneObject(get(_defaultValues, name))) : _getDirty();
      }
      if (!options.keepError) {
        unset(_formState.errors, name);
        _proxyFormState.isValid && _updateValid();
      }
      _subjects.state.next({ ..._formState });
    }
  };
  const _reset = (formValues, keepStateOptions = {}) => {
    const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
    const cloneUpdatedValues = cloneObject(updatedValues);
    const isEmptyResetValues = isEmptyObject(formValues);
    const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
    if (!keepStateOptions.keepDefaultValues) {
      _defaultValues = updatedValues;
    }
    if (!keepStateOptions.keepValues) {
      if (keepStateOptions.keepDirtyValues) {
        for (const fieldName of _names.mount) {
          get(_formState.dirtyFields, fieldName) ? set(values, fieldName, get(_formValues, fieldName)) : setValue(fieldName, get(values, fieldName));
        }
      } else {
        if (isWeb && isUndefined(formValues)) {
          for (const name of _names.mount) {
            const field = get(_fields, name);
            if (field && field._f) {
              const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
              if (isHTMLElement(fieldReference)) {
                const form = fieldReference.closest("form");
                if (form) {
                  form.reset();
                  break;
                }
              }
            }
          }
        }
        _fields = {};
      }
      _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? cloneObject(_defaultValues) : {} : cloneObject(values);
      _subjects.array.next({
        values: { ...values }
      });
      _subjects.values.next({
        values: { ...values }
      });
    }
    _names = {
      mount: keepStateOptions.keepDirtyValues ? _names.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: false,
      focus: ""
    };
    _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
    _state.watch = !!props.shouldUnregister;
    _subjects.state.next({
      submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
      isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !deepEqual(formValues, _defaultValues)),
      isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
      dirtyFields: isEmptyResetValues ? [] : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
      touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
      errors: keepStateOptions.keepErrors ? _formState.errors : {},
      isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
      isSubmitting: false
    });
  };
  const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
  const setFocus = (name, options = {}) => {
    const field = get(_fields, name);
    const fieldReference = field && field._f;
    if (fieldReference) {
      const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
      if (fieldRef.focus) {
        fieldRef.focus();
        options.shouldSelect && fieldRef.select();
      }
    }
  };
  const _updateFormState = (updatedFormState) => {
    _formState = {
      ..._formState,
      ...updatedFormState
    };
  };
  const _resetDefaultValues = () => isFunction(_options.defaultValues) && _options.defaultValues().then((values) => {
    reset(values, _options.resetOptions);
    _subjects.state.next({
      isLoading: false
    });
  });
  return {
    control: {
      register,
      unregister,
      getFieldState,
      handleSubmit,
      setError,
      _executeSchema,
      _getWatch,
      _getDirty,
      _updateValid,
      _removeUnmounted,
      _updateFieldArray,
      _updateDisabledField,
      _getFieldArray,
      _reset,
      _resetDefaultValues,
      _updateFormState,
      _disableForm,
      _subjects,
      _proxyFormState,
      _setErrors,
      get _fields() {
        return _fields;
      },
      get _formValues() {
        return _formValues;
      },
      get _state() {
        return _state;
      },
      set _state(value) {
        _state = value;
      },
      get _defaultValues() {
        return _defaultValues;
      },
      get _names() {
        return _names;
      },
      set _names(value) {
        _names = value;
      },
      get _formState() {
        return _formState;
      },
      set _formState(value) {
        _formState = value;
      },
      get _options() {
        return _options;
      },
      set _options(value) {
        _options = {
          ..._options,
          ...value
        };
      }
    },
    trigger,
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    resetField,
    clearErrors,
    unregister,
    setError,
    setFocus,
    getFieldState
  };
}
function useForm(props = {}) {
  const _formControl = React__default.useRef();
  const _values = React__default.useRef();
  const [formState, updateFormState] = React__default.useState({
    isDirty: false,
    isValidating: false,
    isLoading: isFunction(props.defaultValues),
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: props.errors || {},
    disabled: props.disabled || false,
    defaultValues: isFunction(props.defaultValues) ? void 0 : props.defaultValues
  });
  if (!_formControl.current) {
    _formControl.current = {
      ...createFormControl(props),
      formState
    };
  }
  const control = _formControl.current.control;
  control._options = props;
  useSubscribe({
    subject: control._subjects.state,
    next: (value) => {
      if (shouldRenderFormState(value, control._proxyFormState, control._updateFormState)) {
        updateFormState({ ...control._formState });
      }
    }
  });
  React__default.useEffect(() => control._disableForm(props.disabled), [control, props.disabled]);
  React__default.useEffect(() => {
    if (control._proxyFormState.isDirty) {
      const isDirty = control._getDirty();
      if (isDirty !== formState.isDirty) {
        control._subjects.state.next({
          isDirty
        });
      }
    }
  }, [control, formState.isDirty]);
  React__default.useEffect(() => {
    if (props.values && !deepEqual(props.values, _values.current)) {
      control._reset(props.values, control._options.resetOptions);
      _values.current = props.values;
      updateFormState((state) => ({ ...state }));
    } else {
      control._resetDefaultValues();
    }
  }, [props.values, control]);
  React__default.useEffect(() => {
    if (props.errors) {
      control._setErrors(props.errors);
    }
  }, [props.errors, control]);
  React__default.useEffect(() => {
    if (!control._state.mount) {
      control._updateValid();
      control._state.mount = true;
    }
    if (control._state.watch) {
      control._state.watch = false;
      control._subjects.state.next({ ...control._formState });
    }
    control._removeUnmounted();
  });
  React__default.useEffect(() => {
    props.shouldUnregister && control._subjects.values.next({
      values: control._getWatch()
    });
  }, [props.shouldUnregister, control]);
  _formControl.current.formState = getProxyFormState(formState, control);
  return _formControl.current;
}
function EditBotModal() {
  const { register, watch, handleSubmit, setValue, reset } = useForm({
    defaultValues: {
      room_name: "",
      prompt: "you are a helpful ai assistant.always trust RAG and tools, if you do not know the answer dont make anything up.",
      tempature: 0.7,
      recontextualize_query: true,
      use_rag: true,
      rag_similarity_score_min: 0.7,
      history_size: 25,
      context_size: 8192
    }
  });
  const [isLoading, setLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [preview, getPreview] = usePreview();
  const { roomDescription, addRoom, getChatroom, updateRoom } = useSupabase();
  const { editChatroomState, setIsEditChatroomModalShow, currentChatroom, setToastInfo, isEditChatroomModalShow } = useChatroom();
  const classPrefix = "edit-bot-modal";
  const avatarInputRef = useRef(null);
  const fieldRequirements = {
    room_name: {
      required: "Please enter the bot name."
    },
    avatar: {},
    prompt: {
      required: "Please enter the prompt."
    },
    tempature: {
      required: "Please enter the tempature."
    },
    rag_similarity_score_min: {
      required: "Please enter the RAG similarity score."
    },
    history_size: {
      required: "Please enter the history size."
    },
    context_size: {
      required: "Please enter the context size."
    },
    recontextualize_query: {},
    use_rag: {}
  };
  const watch_recontextualize_query = watch("recontextualize_query");
  const watch_use_rag = watch("use_rag");
  const handleAvatarUpload = (event) => {
    var _a;
    const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
    setValue("avatar", file);
    getPreview(file !== null && file !== void 0 ? file : null);
  };
  const onCloseModal = () => {
    setIsEditChatroomModalShow(false);
  };
  const onUseRAGChange = (isCheck) => {
    setValue("use_rag", isCheck);
  };
  const onRecontextualizeChange = (isCheck) => {
    setValue("recontextualize_query", isCheck);
  };
  const getRoomDescription = (room_id) => __awaiter(this, void 0, void 0, function* () {
    var _a;
    try {
      setLoading(true);
      const description = yield roomDescription(room_id);
      const _b = description, { app_name, ai_room, use_tools } = _b, data = __rest(_b, ["app_name", "ai_room", "use_tools"]);
      setValue("room_name", (_a = currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.name) !== null && _a !== void 0 ? _a : "");
      setValue("context_size", data.context_size);
      setValue("history_size", data.history_size);
      setValue("prompt", data.prompt);
      setValue("tempature", data.tempature);
      setValue("rag_similarity_score_min", data.rag_similarity_score_min);
      setValue("use_rag", data.use_rag);
    } catch (error) {
      setToastInfo({ type: "error", message: error.message });
    } finally {
      setLoading(false);
    }
  });
  const isCreate = editChatroomState === "Create";
  const onSubmit = (form) => __awaiter(this, void 0, void 0, function* () {
    try {
      setIsSubmitLoading(true);
      const { room_name, avatar, tempature, rag_similarity_score_min, history_size, context_size } = form, data = __rest(
        form,
        ["room_name", "avatar", "tempature", "rag_similarity_score_min", "history_size", "context_size"]
      );
      const _number_form = {
        tempature: Number(tempature),
        rag_similarity_score_min: Number(rag_similarity_score_min),
        history_size: Number(history_size),
        context_size: Number(context_size)
      };
      const _form = Object.assign(Object.assign({}, data), _number_form);
      if (isCreate) {
        yield addRoom(room_name, _form, avatar);
        yield getChatroom();
        setToastInfo({ type: "success", message: "Created Successfully." });
        setIsEditChatroomModalShow(false);
      } else {
        if (!currentChatroom || !currentChatroom.room_id) {
          throw new Error("Current bot not found.");
        }
        yield updateRoom(currentChatroom.room_id, _form, room_name, avatar);
        yield getChatroom();
        setToastInfo({ type: "success", message: "Updated Successfully." });
        setIsEditChatroomModalShow(false);
      }
    } catch (error) {
      setToastInfo({ type: "error", message: error.message });
    } finally {
      setIsSubmitLoading(false);
    }
  });
  const renderAvatar = () => {
    if (preview) {
      return jsxRuntimeExports.jsx("img", { src: preview, alt: "avatar" });
    }
    if (currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.avatar) {
      return jsxRuntimeExports.jsx("img", { src: currentChatroom.avatar, alt: "avatar" });
    }
    return jsxRuntimeExports.jsx(ChatSVG, {});
  };
  useEffect(() => {
    if (!isEditChatroomModalShow) {
      reset();
      getPreview(null);
    } else {
      if (editChatroomState === "Update" && (currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.room_id)) {
        getRoomDescription(currentChatroom.room_id);
      }
    }
  }, [isEditChatroomModalShow]);
  return jsxRuntimeExports.jsx(CommonModal, { onRequestClose: onCloseModal, style: {
    content: {
      inset: "auto auto",
      maxWidth: "420px",
      width: "100%",
      height: "auto"
    },
    overlay: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, isOpen: isEditChatroomModalShow, ariaHideApp: false, children: jsxRuntimeExports.jsxs("section", { className: `${classPrefix}`, children: [jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-header`, children: [jsxRuntimeExports.jsxs("span", { children: [editChatroomState, " Your Bot"] }), jsxRuntimeExports.jsx("button", { onClick: onCloseModal, children: jsxRuntimeExports.jsx(CloseSVG, {}) })] }), jsxRuntimeExports.jsx("div", { className: `${classPrefix}-content`, children: isLoading || isSubmitLoading ? jsxRuntimeExports.jsx("div", { className: "loading-wrapper", children: jsxRuntimeExports.jsx(Loading, {}) }) : jsxRuntimeExports.jsxs("form", { onSubmit: handleSubmit(onSubmit), children: [jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-content__avatar`, children: [jsxRuntimeExports.jsxs("div", { onClick: () => {
    var _a;
    if (avatarInputRef === null || avatarInputRef === void 0 ? void 0 : avatarInputRef.current)
      (_a = avatarInputRef === null || avatarInputRef === void 0 ? void 0 : avatarInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
  }, className: `${classPrefix}-content__avatar-content`, children: [jsxRuntimeExports.jsx("div", { className: "avatar-wrapper", children: renderAvatar() }), jsxRuntimeExports.jsx(EditAvatarSVG, { className: "upload-svg" }), jsxRuntimeExports.jsx("input", { className: "hidden", type: "file", accept: "image/*", ref: avatarInputRef, onChange: handleAvatarUpload })] }), jsxRuntimeExports.jsxs("span", { children: [isCreate ? "Upload" : "Edit", " Avatar"] })] }), jsxRuntimeExports.jsx("div", { className: "form-control", children: jsxRuntimeExports.jsx("input", Object.assign({ placeholder: "Enter Bot Name" }, register("room_name", fieldRequirements.room_name))) }), jsxRuntimeExports.jsxs("div", { className: "form-control", children: [jsxRuntimeExports.jsx("label", { children: "System Prompt" }), jsxRuntimeExports.jsx("textarea", Object.assign({ placeholder: "System Prompt" }, register("prompt", fieldRequirements.prompt)))] }), jsxRuntimeExports.jsxs("div", { className: "form-control", children: [jsxRuntimeExports.jsx("label", { children: "Tempature" }), jsxRuntimeExports.jsx("input", Object.assign({ min: 0, max: 1, step: 0.1, placeholder: "Tempature", type: "number" }, register("tempature", fieldRequirements.tempature)))] }), jsxRuntimeExports.jsxs("div", { className: "form-control-switch", children: [jsxRuntimeExports.jsx("label", { children: "Recontextualize" }), jsxRuntimeExports.jsx(Switch, { defaultChecked: watch_recontextualize_query, onChange: onRecontextualizeChange })] }), jsxRuntimeExports.jsxs("div", { className: "form-control-switch", children: [jsxRuntimeExports.jsx("label", { children: "Use RAG" }), jsxRuntimeExports.jsx(Switch, { defaultChecked: watch_use_rag, onChange: onUseRAGChange })] }), jsxRuntimeExports.jsxs("div", { className: "form-control", children: [jsxRuntimeExports.jsx("label", { children: "RAG similarity score min" }), jsxRuntimeExports.jsx("input", Object.assign({ min: 0, max: 1, step: 0.1, disabled: !watch_use_rag }, register("rag_similarity_score_min", fieldRequirements.rag_similarity_score_min), { placeholder: "RAG similarity score min", type: "number" }))] }), jsxRuntimeExports.jsxs("div", { className: "flex-wrapper", children: [jsxRuntimeExports.jsxs("div", { className: "form-control", children: [jsxRuntimeExports.jsx("label", { children: "History size" }), jsxRuntimeExports.jsx("input", Object.assign({ min: 1, type: "number" }, register("history_size", fieldRequirements.history_size)))] }), jsxRuntimeExports.jsxs("div", { className: "form-control", children: [jsxRuntimeExports.jsx("label", { children: "Context Size" }), jsxRuntimeExports.jsx("input", Object.assign({ min: 1, type: "number" }, register("context_size", fieldRequirements.context_size)))] })] }), jsxRuntimeExports.jsx("button", { type: "submit", children: editChatroomState })] }) })] }) });
}
const NoFileDisplay = ({ roomID }) => {
  const { setFiles, files, setToastInfo } = useChatroom();
  const { roomUploadFile, fileList } = useSupabase();
  const [isLoading, startTransition] = useTransition();
  const ref = useRef(null);
  const filesArr = files;
  const onUploadFile = (event) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
    if (!file)
      return;
    uploadFile(file);
  });
  const uploadFile = (file) => {
    startTransition(() => {
      (() => __awaiter(void 0, void 0, void 0, function* () {
        try {
          yield roomUploadFile(file, roomID);
          setToastInfo({ type: "success", message: "Upload Successfully." });
          setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
            const files2 = (yield fileList(roomID)).slice(-1).map((_) => Object.assign(Object.assign({}, _), { isChecked: false, isHide: false, isSetting: false }));
            const newFiles = [...filesArr, ...files2];
            setFiles(newFiles);
          }), 1e3);
        } catch (error) {
          if (error.message === "new row violates row-level security policy") {
            setToastInfo({ type: "error", message: "The file already exists." });
          } else {
            setToastInfo({ type: "error", message: error.message });
          }
        }
      }))();
    });
  };
  return jsxRuntimeExports.jsx("div", { className: "no-file", children: isLoading ? jsxRuntimeExports.jsx(Loading, {}) : jsxRuntimeExports.jsxs("div", { className: "no-file-content", children: [jsxRuntimeExports.jsx("img", { src: "/images/no-file.png", alt: "no file" }), jsxRuntimeExports.jsx("h3", { children: "No File Yet" }), jsxRuntimeExports.jsxs("p", { children: ["You can add Files here and all Files ", jsxRuntimeExports.jsx("br", {}), " are displayed here."] }), jsxRuntimeExports.jsx("button", { onClick: () => {
    var _a;
    return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.click();
  }, children: "Upload File" }), jsxRuntimeExports.jsx("input", { type: "file", ref, onChange: onUploadFile })] }) });
};
const handleShowIcon$1 = (file) => {
  const fileType = getFileType(file);
  return jsxRuntimeExports.jsx("img", { src: `/images/${fileType}.png`, alt: file });
};
function FilesModal() {
  const { downloadFile } = useSupabase();
  const { isFilesModalShow, setIsFilesModalShow, setFiles, files, setToastInfo, currentChatroom, bidContactDocumentName, specificationDocumentName, setBidContactDocumentName, setSpecificationDocumentName, selectFileType, setIsRemoveFileModalShow, setRemoveFileName } = useChatroom();
  const classPrefix = "files-modal";
  const [isHasBidCheck, setHasBidCheck] = useState(false);
  const [isHasSpecCheck, setHasSpecCheck] = useState(false);
  useEffect(() => {
    const isHasOneChecked = files.filter((_) => _.isChecked).length === 1;
    const isHasOneChoose = files.filter((_) => _.isHide).length === 1 && files.filter((_) => _.isChecked).length === 2;
    setHasBidCheck(isHasOneChecked);
    setHasSpecCheck(isHasOneChoose);
  }, [files]);
  const menuRef = useRef(null);
  const isFileConfirm = (file) => {
    if (selectFileType === "bid") {
      if (bidContactDocumentName === file.name)
        return true;
      return false;
    }
    if (selectFileType === "spec") {
      if (specificationDocumentName === file.name)
        return true;
      return false;
    }
    return false;
  };
  const onCloseModal = () => {
    setFiles((prev) => {
      return prev.map((_file) => {
        return Object.assign(Object.assign({}, _file), { isChecked: isFileConfirm(_file) });
      });
    });
    setIsFilesModalShow(false);
  };
  const onDeleteFile = (file) => {
    return (event) => {
      event.stopPropagation();
      setIsRemoveFileModalShow(true);
      setRemoveFileName(file.name);
    };
  };
  const onOpenSetting = (file) => {
    return (event) => {
      event.stopPropagation();
      setFiles((prev) => {
        return prev.map((_file) => {
          return Object.assign(Object.assign({}, _file), { isSetting: file.id === _file.id });
        });
      });
    };
  };
  const handleOutsideClick = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setFiles((prev) => {
        return prev.map((_file) => {
          return Object.assign(Object.assign({}, _file), { isSetting: false });
        });
      });
    }
  };
  const downloadTheFile = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };
  const onDownloadFile = (file) => {
    return (event) => __awaiter(this, void 0, void 0, function* () {
      event.stopPropagation();
      if (!(currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.room_id))
        return;
      const _blob = yield downloadFile(currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.room_id, file.name);
      downloadTheFile(_blob, file.name);
      setFiles((prev) => {
        return prev.map((_file) => {
          if (file.id === _file.id) {
            return Object.assign(Object.assign({}, _file), { isSetting: false });
          }
          return Object.assign({}, _file);
        });
      });
    });
  };
  useEffect(() => {
    if (files.find((_) => _.isSetting)) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      if (!files.find((_) => _.isSetting)) {
        document.removeEventListener("mousedown", handleOutsideClick);
      }
    };
  }, [files]);
  const onSelectFile = (file) => {
    return () => {
      setFiles((prev) => {
        const _files = prev.map((_) => {
          const isCurrent = _.id === file.id;
          if (isCurrent && file.isChecked && bidContactDocumentName === file.name) {
            setBidContactDocumentName("");
          }
          if (isCurrent && file.isChecked && specificationDocumentName === file.name) {
            setSpecificationDocumentName("");
          }
          return Object.assign(Object.assign({}, _), { isChecked: isCurrent ? !_.isChecked : _.isHide });
        });
        return _files;
      });
    };
  };
  const onHandleConfirm = () => {
    const selectFile = files.find((_) => _.isChecked && !_.isHide);
    if (selectFile) {
      selectFileType === "bid" ? setBidContactDocumentName(selectFile.name) : setSpecificationDocumentName(selectFile.name);
      setIsFilesModalShow(false);
    } else {
      return setToastInfo({ type: "error", message: "Unknown Error" });
    }
    setFiles((prev) => {
      const _files = prev.map((_) => {
        return Object.assign(Object.assign({}, _), { isHide: _.isChecked });
      });
      return _files;
    });
  };
  useEffect(() => {
    if (isFilesModalShow) {
      setFiles((prev) => {
        const _selectName = selectFileType === "bid" ? bidContactDocumentName : specificationDocumentName;
        const _otherSelectName = selectFileType === "bid" ? specificationDocumentName : bidContactDocumentName;
        const _files = prev.map((_) => {
          return Object.assign(Object.assign({}, _), { isChecked: _.name === _selectName, isHide: _.name === _otherSelectName });
        });
        return _files;
      });
    }
  }, [isFilesModalShow]);
  if (!(currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.room_id))
    return;
  return jsxRuntimeExports.jsx(CommonModal, { style: {
    overlay: {
      zIndex: 102
    },
    content: {
      zIndex: 1002,
      height: "100%",
      width: "100%",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      border: "none",
      borderRadius: "0"
    }
  }, onRequestClose: onCloseModal, isOpen: isFilesModalShow, ariaHideApp: false, children: jsxRuntimeExports.jsxs("section", { className: `${classPrefix}`, children: [jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-header`, children: [jsxRuntimeExports.jsx("span", { children: "File History" }), jsxRuntimeExports.jsx("button", { onClick: onCloseModal, children: jsxRuntimeExports.jsx(CloseSVG, {}) })] }), jsxRuntimeExports.jsx("div", { className: `${classPrefix}-content`, children: files.length === 0 || files.length === 1 && files[0].isHide ? jsxRuntimeExports.jsx(NoFileDisplay, { roomID: currentChatroom.room_id }) : jsxRuntimeExports.jsx("ul", { className: `${classPrefix}-list`, children: files.map((file) => {
    if (file.isHide)
      return "";
    return jsxRuntimeExports.jsxs("li", { onClick: onSelectFile(file), className: `item  ${file.isChecked ? "check" : ""}`, children: [jsxRuntimeExports.jsxs("div", { className: "top", children: [jsxRuntimeExports.jsx("div", { className: "check_icon pc", children: jsxRuntimeExports.jsx(CheckSVG, { isCheck: file.isChecked }) }), jsxRuntimeExports.jsx("div", { className: "file_action", onClick: onOpenSetting(file), children: jsxRuntimeExports.jsx(FileAction, { width: "5", height: "16", viewBox: "0 0 5 16", fill: "#313133", xmlns: "http://www.w3.org/2000/svg" }) }), file.isSetting && jsxRuntimeExports.jsxs("div", { className: "menu", ref: menuRef, children: [jsxRuntimeExports.jsx("button", { onClick: onDeleteFile(file), className: "btn delete", children: "Delete" }), jsxRuntimeExports.jsx("button", { onClick: onDownloadFile(file), className: "btn download", children: "Download" })] })] }), jsxRuntimeExports.jsxs("div", { className: "box", children: [jsxRuntimeExports.jsx("div", { className: "file-img", children: handleShowIcon$1(file.name) }), jsxRuntimeExports.jsxs("div", { className: "content", children: [jsxRuntimeExports.jsx("div", { className: "name", children: file.name }), jsxRuntimeExports.jsx("div", { className: "line" }), jsxRuntimeExports.jsxs("div", { className: "desc", children: [jsxRuntimeExports.jsx("div", { className: "size", children: formatFileSize(file.metadata.size) }), jsxRuntimeExports.jsx("div", { className: "date", children: dayjs(file.created_at).format("MMM DD, YYYY") })] })] }), jsxRuntimeExports.jsx("div", { className: "check_icon mobile", children: jsxRuntimeExports.jsx(CheckSVG, { isCheck: file.isChecked }) })] })] }, file.id);
  }) }) }), jsxRuntimeExports.jsx("div", { className: `${classPrefix}-button-group`, children: (isHasBidCheck || isHasSpecCheck) && jsxRuntimeExports.jsx("button", { type: "button", onClick: onHandleConfirm, children: "Confirm" }) })] }) });
}
const handleShowIcon = (file) => {
  const fileType = file.substring(file.lastIndexOf(".") + 1);
  if (["doc", "docx", "xlsx", "ppt", "pptx", "pdf"].includes(fileType)) {
    return jsxRuntimeExports.jsx("img", { src: `/images/${fileType}.png`, alt: file });
  }
  return jsxRuntimeExports.jsx("img", { src: `/images/file.png`, alt: file });
};
function FillFormModal() {
  const { downloadFile, fileList } = useSupabase();
  const { isFillFormModalShow, setIsFillFormModalShow, setFiles, files, setToastInfo, currentChatroom, bidContactDocumentName, specificationDocumentName, setBidContactDocumentName, setSpecificationDocumentName, setIsRemoveFileModalShow, setRemoveFileName } = useChatroom();
  const classPrefix = "fill-form-modal";
  const menuRef = useRef(null);
  const onCloseModal = () => {
    setFiles((prev) => {
      return prev.map((_file) => {
        return Object.assign(Object.assign({}, _file), { isChecked: false });
      });
    });
    setIsFillFormModalShow(false);
  };
  const onDeleteFile = (file) => {
    return (event) => {
      event.stopPropagation();
      setIsRemoveFileModalShow(true);
      setRemoveFileName(file.name);
    };
  };
  const onOpenSetting = (file) => {
    return (event) => {
      event.stopPropagation();
      setFiles((prev) => {
        return prev.map((_file) => {
          return Object.assign(Object.assign({}, _file), { isSetting: file.id === _file.id });
        });
      });
    };
  };
  const handleOutsideClick = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setFiles((prev) => {
        return prev.map((_file) => {
          return Object.assign(Object.assign({}, _file), { isSetting: false });
        });
      });
    }
  };
  const downloadTheFile = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };
  const onDownloadFile = (file) => {
    return (event) => __awaiter(this, void 0, void 0, function* () {
      event.stopPropagation();
      if (!(currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.room_id))
        return;
      const _blob = yield downloadFile(currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.room_id, file.name);
      downloadTheFile(_blob, file.name);
      setFiles((prev) => {
        return prev.map((_file) => {
          if (file.id === _file.id) {
            return Object.assign(Object.assign({}, _file), { isSetting: false });
          }
          return Object.assign({}, _file);
        });
      });
    });
  };
  useEffect(() => {
    if (files.find((_) => _.isSetting)) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      if (!files.find((_) => _.isSetting)) {
        document.removeEventListener("mousedown", handleOutsideClick);
      }
    };
  }, [files]);
  const getFiles = () => __awaiter(this, void 0, void 0, function* () {
    try {
      if (!(currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.room_id))
        return;
      const _files = (yield fileList(currentChatroom.room_id)).map((_) => Object.assign(Object.assign({}, _), { isChecked: false, isHide: false, isSetting: false }));
      setFiles(_files);
    } catch (error) {
      setToastInfo({ type: "error", message: error.message });
    }
  });
  useEffect(() => {
    if (isFillFormModalShow) {
      getFiles();
    }
  }, [isFillFormModalShow]);
  const onSelectFile = (file) => {
    return () => {
      setFiles((prev) => {
        const _files = prev.map((_) => {
          const isCurrent = _.id === file.id;
          if (isCurrent && file.isChecked && bidContactDocumentName === file.name) {
            setBidContactDocumentName("");
          }
          if (isCurrent && file.isChecked && specificationDocumentName === file.name) {
            setSpecificationDocumentName("");
          }
          return Object.assign(Object.assign({}, _), { isChecked: isCurrent ? !_.isChecked : _.isHide });
        });
        return _files;
      });
    };
  };
  const onHandleConfirm = () => {
    const selectFile = files.find((_) => _.isChecked && !_.isHide);
    if (selectFile) {
      setIsFillFormModalShow(false);
    } else {
      return setToastInfo({ type: "error", message: "Unknown Error" });
    }
  };
  if (!(currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.room_id))
    return;
  return jsxRuntimeExports.jsx(CommonModal, { onRequestClose: onCloseModal, style: {
    overlay: {
      zIndex: 101
    },
    content: {
      zIndex: 1001,
      height: "100%",
      width: "100%",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      border: "none",
      borderRadius: "0"
    }
  }, isOpen: isFillFormModalShow, ariaHideApp: false, children: jsxRuntimeExports.jsxs("section", { className: `${classPrefix}`, children: [jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-header`, children: [jsxRuntimeExports.jsx("span", { children: "File History" }), jsxRuntimeExports.jsx("button", { onClick: onCloseModal, children: jsxRuntimeExports.jsx(CloseSVG, {}) })] }), jsxRuntimeExports.jsx("div", { className: `${classPrefix}-content`, children: files.length === 0 || files.length === 1 && files[0].isHide ? jsxRuntimeExports.jsx(NoFileDisplay, { roomID: currentChatroom.room_id }) : jsxRuntimeExports.jsx("ul", { className: `${classPrefix}-list`, children: files.map((file) => {
    if (file.isHide)
      return "";
    return jsxRuntimeExports.jsxs("li", { onClick: onSelectFile(file), className: `item  ${file.isChecked ? "check" : ""}`, children: [jsxRuntimeExports.jsxs("div", { className: "top", children: [jsxRuntimeExports.jsx("div", { className: "check_icon pc", children: jsxRuntimeExports.jsx(CheckSVG, { isCheck: file.isChecked }) }), jsxRuntimeExports.jsx("div", { className: "file_action", onClick: onOpenSetting(file), children: jsxRuntimeExports.jsx(FileAction, { width: "5", height: "16", viewBox: "0 0 5 16", fill: "#313133", xmlns: "http://www.w3.org/2000/svg" }) }), file.isSetting && jsxRuntimeExports.jsxs("div", { className: "menu", ref: menuRef, children: [jsxRuntimeExports.jsx("button", { onClick: onDeleteFile(file), className: "btn delete", children: "Delete" }), jsxRuntimeExports.jsx("button", { onClick: onDownloadFile(file), className: "btn download", children: "Download" })] })] }), jsxRuntimeExports.jsxs("div", { className: "box", children: [jsxRuntimeExports.jsx("div", { className: "file-img", children: handleShowIcon(file.name) }), jsxRuntimeExports.jsxs("div", { className: "content", children: [jsxRuntimeExports.jsx("div", { className: "name", children: file.name }), jsxRuntimeExports.jsx("div", { className: "line" }), jsxRuntimeExports.jsxs("div", { className: "desc", children: [jsxRuntimeExports.jsx("div", { className: "size", children: formatFileSize(file.metadata.size) }), jsxRuntimeExports.jsx("div", { className: "date", children: dayjs(file.created_at).format("MMM DD, YYYY") })] })] }), jsxRuntimeExports.jsx("div", { className: "check_icon mobile", children: jsxRuntimeExports.jsx(CheckSVG, { isCheck: file.isChecked }) })] })] }, file.id);
  }) }) }), jsxRuntimeExports.jsx("div", { className: `${classPrefix}-button-group`, children: jsxRuntimeExports.jsx("button", { type: "button", onClick: onHandleConfirm, children: "Confirm" }) })] }) });
}
function RemoveChatroom() {
  const { removeRoom, getChatroom } = useSupabase();
  const { isAddBotModalShow, setIsAddBotModalShow, currentChatroom, setToastInfo } = useChatroom();
  const classPrefix = "removeChatroom-modal";
  const [isLoading, setLoading] = useState(false);
  const onCloseModal = () => {
    setIsAddBotModalShow(false);
  };
  const onRemove = () => __awaiter(this, void 0, void 0, function* () {
    if (!currentChatroom || !currentChatroom.room_id)
      return;
    try {
      setLoading(true);
      yield removeRoom(currentChatroom.room_id);
      setToastInfo({ type: "success", message: "Removed Successfully." });
      yield getChatroom();
      onCloseModal();
    } catch (error) {
      setToastInfo({ type: "error", message: error.message });
    } finally {
      setLoading(false);
    }
  });
  return jsxRuntimeExports.jsx(CommonModal, { onRequestClose: onCloseModal, style: {
    overlay: {
      zIndex: 103
    },
    content: {
      zIndex: 1003,
      maxWidth: "400px",
      height: "190px",
      width: "100%",
      backgroundColor: "#2c2d30",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    }
  }, isOpen: isAddBotModalShow, ariaHideApp: false, children: jsxRuntimeExports.jsxs("section", { className: `${classPrefix}`, children: [jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-header`, children: [jsxRuntimeExports.jsx("span", { children: "Remove Bot" }), jsxRuntimeExports.jsx("button", { onClick: onCloseModal, children: jsxRuntimeExports.jsx(CloseSVG, {}) })] }), isLoading ? jsxRuntimeExports.jsx("div", { className: "loading-wrapper", children: jsxRuntimeExports.jsx(Loading, {}) }) : jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-wrapper`, children: [jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-content`, children: ["Are you sure you want to remove bot ", jsxRuntimeExports.jsx("span", { className: "text-error", children: currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.name }), " ?"] }), jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-button`, children: [jsxRuntimeExports.jsx("button", { onClick: onCloseModal, className: `${classPrefix}-button__cancel`, children: "Cancel" }), jsxRuntimeExports.jsx("button", { disabled: isLoading, onClick: onRemove, className: `${classPrefix}-button__remove`, children: "Remove" })] })] })] }) });
}
function RemoveFile() {
  const classPrefix = "remove-file";
  const { removeFile } = useSupabase();
  const [isLoading, setIsLoading] = useState(false);
  const { isRemoveFileModalShow, removeFileName, currentChatroom, setIsRemoveFileModalShow, setRemoveFileName, specificationDocumentName, setSpecificationDocumentName, setBidContactDocumentName, bidContactDocumentName, setToastInfo, setFiles, files } = useChatroom();
  const onRemove = () => __awaiter(this, void 0, void 0, function* () {
    if (!(currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.room_id))
      return;
    try {
      setIsLoading(true);
      if (!removeFileName)
        return;
      yield removeFile(currentChatroom.room_id, removeFileName);
      setToastInfo({ type: "success", message: "Removed Successfully." });
      if (bidContactDocumentName === removeFileName) {
        setBidContactDocumentName("");
      }
      if (specificationDocumentName === removeFileName) {
        setSpecificationDocumentName("");
      }
      setFiles(files.filter((_) => _.name !== removeFileName));
    } catch (error) {
      setToastInfo({ type: "error", message: error.message });
    } finally {
      setIsLoading(false);
      onClose();
    }
  });
  const onClose = () => {
    setIsRemoveFileModalShow(false);
    setRemoveFileName(null);
  };
  return jsxRuntimeExports.jsx(CommonModal, { onRequestClose: onClose, style: {
    overlay: {
      zIndex: 105
    },
    content: {
      zIndex: 1005,
      maxWidth: "400px",
      height: "190px",
      width: "100%",
      backgroundColor: "#2c2d30",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    }
  }, isOpen: isRemoveFileModalShow, ariaHideApp: false, children: jsxRuntimeExports.jsxs("section", { className: `${classPrefix}`, children: [jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-header`, children: [jsxRuntimeExports.jsx("span", { children: "Remove File" }), jsxRuntimeExports.jsx("button", { onClick: onClose, children: jsxRuntimeExports.jsx(CloseSVG, {}) })] }), isLoading ? jsxRuntimeExports.jsx("div", { className: "loading-wrapper", children: jsxRuntimeExports.jsx(Loading, {}) }) : jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-wrapper`, children: [jsxRuntimeExports.jsxs("p", { className: `${classPrefix}-content`, children: ["Are you sure you want to delete file ", jsxRuntimeExports.jsx("span", { children: removeFileName }), "?"] }), jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-button`, children: [jsxRuntimeExports.jsx("button", { onClick: onClose, className: `${classPrefix}-button__cancel`, children: "Cancel" }), jsxRuntimeExports.jsxs("button", { disabled: isLoading, onClick: onRemove, className: `${classPrefix}-button__remove`, children: ["Remove", isLoading && jsxRuntimeExports.jsx(Loading, {})] })] })] })] }) });
}
const useListenerMessage = ({ app_name, supabase_public, supabase_public_chat, isChatWithAi }) => {
  const { user, messages, chatroomList, currentChatroom, setChatroomList, setMessages, setBotMessage, setIsGenerating } = useChatroom();
  const { userProfile, getUserCommentEmoji, getPublicChannels } = useSupabase();
  if (!app_name)
    throw new Error("Please fill your app name.");
  if (!supabase_public)
    throw new Error("Please fill in the instance of supabase whose schema is public.");
  if (!supabase_public_chat)
    throw new Error("Please fill in the instance of supabase whose schema is public_chat.");
  const [newMessage, setNewMessage] = useState(null);
  const [insertSubscribable, setInsertSubscribable] = useState(null);
  const [updateSubscribable, setUpdateSubscribable] = useState(null);
  const createSubscription = (name) => {
    return supabase_public_chat.channel(name);
  };
  const getCommonChannelsIds = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
      const result = yield getPublicChannels();
      return (_a = result && result.map((_) => _.room_id)) !== null && _a !== void 0 ? _a : [];
    } catch (error) {
      console.log(error);
    }
  });
  const getUserInfo = (user_id) => __awaiter(void 0, void 0, void 0, function* () {
    const { data, error } = yield supabase_public.from("users_view").select("user_name,email,avatar").eq("user_id", user_id).single();
    if (error)
      throw new Error(error.message);
    return data;
  });
  const updateChatRoomsMessage = ({ roomID, latest_message, message_time }) => {
    const index2 = chatroomList.findIndex((room) => room.room_id === roomID);
    if (index2 >= 0) {
      if (currentChatroom && currentChatroom.room_id === roomID) {
        chatroomList[index2] = Object.assign(Object.assign({}, chatroomList[index2]), {
          message_time,
          latest_message
        });
      } else {
        chatroomList[index2] = Object.assign(Object.assign({}, chatroomList[index2]), {
          message_time,
          latest_message,
          new_message_count: chatroomList[index2].new_message_count + 1
        });
      }
      setChatroomList([...chatroomList]);
    }
  };
  const onCreateRoomMessageSubscribable = (name) => __awaiter(void 0, void 0, void 0, function* () {
    const user2 = yield userProfile();
    const channelIds = yield getCommonChannelsIds();
    if (!channelIds)
      return;
    if (!user2)
      return;
    const id = user2.id;
    const subscription = createSubscription(id !== null && id !== void 0 ? id : name);
    subscription.on("postgres_changes", {
      event: "INSERT",
      schema: "public_chat",
      table: "room_messages"
    }, (_a) => __awaiter(void 0, [_a], void 0, function* ({ new: message }) {
      if (!isChatWithAi) {
        if (!channelIds.includes(message.message_id)) {
          handleCheckIsGroup(message);
        }
      } else {
        const messageContent = JSON.parse(message.message);
        if (["system", "ai"].includes(messageContent.user)) {
          if (messageContent.done) {
            setNewMessage(Object.assign(Object.assign({}, message), { user_name: (currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.name) ? currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.name : "", avatar: (currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.avatar) ? currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.avatar : "", user_emotes: [] }));
          } else {
            requestAnimationFrame(() => {
              if (!("bid-document" in messageContent)) {
                setBotMessage(messageContent === null || messageContent === void 0 ? void 0 : messageContent.message);
              }
            });
          }
        } else {
          if (messageContent.done) {
            if (!user2)
              return;
            setNewMessage(Object.assign(Object.assign({}, message), { user_name: user2.user_metadata.user_name, avatar: user2.user_metadata.avatar, user_emotes: [] }));
          }
        }
      }
    }));
    setInsertSubscribable(subscription);
  });
  const handleCheckIsGroup = (message) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    if (!message.user_id)
      return;
    const user2 = yield getUserInfo(message.user_id);
    if (!user2)
      return;
    const userEmotes = yield getUserCommentEmoji(message.user_id);
    setNewMessage(Object.assign(Object.assign({}, message), { user_name: user2.user_name, avatar: user2.avatar, user_emotes: (_b = (_a = userEmotes === null || userEmotes === void 0 ? void 0 : userEmotes[0]) === null || _a === void 0 ? void 0 : _a.emotes) !== null && _b !== void 0 ? _b : [] }));
  });
  const onCreateMessageUpdateSubscribable = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const subscription = createSubscription((_a = currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.room_id) !== null && _a !== void 0 ? _a : "");
    subscription.on("postgres_changes", {
      event: "UPDATE",
      schema: "public_chat",
      table: "room_messages",
      filter: `room_id=eq.${currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.room_id}`
    }, (_a2) => __awaiter(void 0, [_a2], void 0, function* ({ new: message }) {
      if (isChatWithAi) {
        const messageContent = JSON.parse(message.message);
        if (["system", "ai"].includes(messageContent.user)) {
          setIsGenerating(!messageContent.done);
          if (messageContent.done) {
            setNewMessage(Object.assign(Object.assign({}, message), { user_name: (currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.name) ? currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.name : "", avatar: (currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.avatar) ? currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.avatar : "", user_emotes: [] }));
          } else {
            requestAnimationFrame(() => {
              if (!("bid-document" in messageContent)) {
                setBotMessage(messageContent === null || messageContent === void 0 ? void 0 : messageContent.message);
              }
            });
          }
        } else {
          if (messageContent.done) {
            if (!user)
              return;
            setNewMessage(Object.assign(Object.assign({}, message), { user_name: user.user_metadata.user_name, avatar: user.user_metadata.avatar, user_emotes: [] }));
          }
        }
      } else {
        setMessages((prev) => {
          return prev.map((item) => {
            if (item.message_id === message.message_id) {
              return Object.assign(Object.assign({}, item), { message_emotes: message.message_emotes });
            }
            return item;
          });
        });
      }
    }));
    setUpdateSubscribable(subscription);
  });
  useEffect(() => {
    if (newMessage) {
      if (newMessage.room_id === (currentChatroom === null || currentChatroom === void 0 ? void 0 : currentChatroom.room_id) && !messages.some((_) => _.message_id === newMessage.message_id)) {
        setMessages((prev) => [...prev, newMessage]);
      }
      if (newMessage.room_id && newMessage.message_time && newMessage.message)
        updateChatRoomsMessage({
          roomID: newMessage.room_id,
          message_time: newMessage.message_time,
          latest_message: newMessage.message
        });
    }
  }, [newMessage]);
  useEffect(() => {
    if (updateSubscribable) {
      updateSubscribable.subscribe();
      return () => {
        updateSubscribable.unsubscribe();
      };
    }
  }, [updateSubscribable]);
  useEffect(() => {
    if (insertSubscribable) {
      insertSubscribable.subscribe();
      return () => {
        insertSubscribable.unsubscribe();
      };
    }
  }, [insertSubscribable]);
  useEffect(() => {
    if (currentChatroom) {
      onCreateMessageUpdateSubscribable();
      return () => {
        updateSubscribable && supabase_public_chat.removeChannel(updateSubscribable);
      };
    }
  }, [currentChatroom]);
  useEffect(() => {
    if (supabase_public_chat && supabase_public && user) {
      onCreateRoomMessageSubscribable();
    }
  }, [supabase_public_chat, supabase_public, currentChatroom, user]);
};
function throttle(method, duration) {
  let timer = null;
  let prevTime = /* @__PURE__ */ new Date();
  return function() {
    const that = this;
    const currentTime = /* @__PURE__ */ new Date();
    const resTime = currentTime.getTime() - prevTime.getTime();
    if (resTime < duration) {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(function() {
        prevTime = currentTime;
        method.apply(that);
      }, duration - resTime);
    } else {
      prevTime = currentTime;
      method.apply(that);
    }
  };
}
function NewFriendsModal({ appName, appVersion }) {
  const { isOpenNewFriendModal, setIsOpenNewFriendModal, setToastInfo } = useChatroom();
  const { newFriendList, inviteFriendsByUserID } = useSupabase();
  const classPrefix = "newFriendsModal-modal";
  const [searchText, setSearchText] = useState("");
  const [friendList, setFriendList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isTyping, setIsTyping] = useState(true);
  useEffect(() => {
    const delay = 500;
    let timer;
    if (isTyping) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        throttledHandleSearch();
      }, delay);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [searchText, isTyping]);
  const handleSearch = () => __awaiter(this, void 0, void 0, function* () {
    if (!searchText.trim())
      return;
    setIsLoading(true);
    try {
      const friendList2 = yield newFriendList(searchText);
      const results = friendList2.map((friend) => {
        return Object.assign(Object.assign({}, friend), { choose: false });
      });
      setFriendList(results);
      setIsLoading(false);
      setIsTyping(false);
    } catch (err) {
      setToastInfo({ type: "error", message: err.message });
      setIsLoading(false);
    }
  });
  const throttledHandleSearch = throttle(handleSearch, 1e3);
  const handleInviteFriends = (item) => __awaiter(this, void 0, void 0, function* () {
    try {
      yield inviteFriendsByUserID({ friendIds: [item.user_id], appName, appVersion });
      setToastInfo({ type: "success", message: "Successfully invited friend." });
    } catch (error) {
      setToastInfo({ type: "error", message: error.message });
    } finally {
      handleSearch();
    }
  });
  const onCloseModal = () => {
    setIsOpenNewFriendModal(false);
  };
  return jsxRuntimeExports.jsx(CommonModal, { onRequestClose: onCloseModal, style: {
    overlay: {
      zIndex: 100
    },
    content: {
      zIndex: 1e3,
      height: "100%",
      width: "100%",
      backgroundColor: "#101A25",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      border: "none",
      borderRadius: "0",
      padding: "0"
    }
  }, isOpen: isOpenNewFriendModal, ariaHideApp: false, children: jsxRuntimeExports.jsxs("section", { className: `${classPrefix}`, children: [jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-header`, children: [jsxRuntimeExports.jsx("button", { onClick: onCloseModal, children: jsxRuntimeExports.jsx(CloseSVG, {}) }), jsxRuntimeExports.jsx("div", { className: "title", children: "New Friends" }), jsxRuntimeExports.jsx("span", { style: { width: "56px" } })] }), jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-content`, children: [jsxRuntimeExports.jsxs("div", { className: "search-bar", children: [jsxRuntimeExports.jsx("input", { type: "text", name: "search", placeholder: "Search new friends", value: searchText, onChange: (e) => __awaiter(this, void 0, void 0, function* () {
    setSearchText(e.target.value);
    setFriendList([]);
    setIsTyping(true);
  }), onKeyUp: (e) => {
    if (e.key === "Enter") {
      throttledHandleSearch();
    }
  } }), jsxRuntimeExports.jsx("span", { onClick: throttledHandleSearch, children: jsxRuntimeExports.jsx(SearchSVG, { width: "20", height: "20", viewBox: "0 0 20 20", fill: "white" }) })] }), isTyping === false && !isLoading ? (friendList === null || friendList === void 0 ? void 0 : friendList.length) > 0 ? jsxRuntimeExports.jsx("ul", { className: `${classPrefix}-list`, children: friendList === null || friendList === void 0 ? void 0 : friendList.map((item) => jsxRuntimeExports.jsxs("li", { style: item.choose ? { background: "#2D323E" } : {}, children: [jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsx("img", { src: item.avatar, alt: "avatar" }) }), jsxRuntimeExports.jsxs("span", { children: [jsxRuntimeExports.jsx("div", { className: "name", children: item.user_name }), jsxRuntimeExports.jsx("div", { className: "invite", onClick: () => handleInviteFriends(item), children: "Invite" })] })] }, item.user_id)) }) : jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-error`, children: [jsxRuntimeExports.jsx("img", { src: "/images/ill.png", alt: "" }), jsxRuntimeExports.jsx("p", { style: { width: "100%", textAlign: "center" }, children: "Friends have been invited or not found." })] }) : jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}), isLoading ? jsxRuntimeExports.jsx(Loading, {}) : jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {})] })] }) });
}
var advancedFormat$1 = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    return function(e, t) {
      var r = t.prototype, n = r.format;
      r.format = function(e2) {
        var t2 = this, r2 = this.$locale();
        if (!this.isValid()) return n.bind(this)(e2);
        var s = this.$utils(), a = (e2 || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e3) {
          switch (e3) {
            case "Q":
              return Math.ceil((t2.$M + 1) / 3);
            case "Do":
              return r2.ordinal(t2.$D);
            case "gggg":
              return t2.weekYear();
            case "GGGG":
              return t2.isoWeekYear();
            case "wo":
              return r2.ordinal(t2.week(), "W");
            case "w":
            case "ww":
              return s.s(t2.week(), "w" === e3 ? 1 : 2, "0");
            case "W":
            case "WW":
              return s.s(t2.isoWeek(), "W" === e3 ? 1 : 2, "0");
            case "k":
            case "kk":
              return s.s(String(0 === t2.$H ? 24 : t2.$H), "k" === e3 ? 1 : 2, "0");
            case "X":
              return Math.floor(t2.$d.getTime() / 1e3);
            case "x":
              return t2.$d.getTime();
            case "z":
              return "[" + t2.offsetName() + "]";
            case "zzz":
              return "[" + t2.offsetName("long") + "]";
            default:
              return e3;
          }
        });
        return n.bind(this)(a);
      };
    };
  });
})(advancedFormat$1);
var advancedFormatExports = advancedFormat$1.exports;
const advancedFormat = /* @__PURE__ */ getDefaultExportFromCjs(advancedFormatExports);
var customParseFormat$1 = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    var e = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, o = {}, s = function(e2) {
      return (e2 = +e2) + (e2 > 68 ? 1900 : 2e3);
    };
    var a = function(e2) {
      return function(t2) {
        this[e2] = +t2;
      };
    }, f = [/[+-]\d\d:?(\d\d)?|Z/, function(e2) {
      (this.zone || (this.zone = {})).offset = function(e3) {
        if (!e3) return 0;
        if ("Z" === e3) return 0;
        var t2 = e3.match(/([+-]|\d\d)/g), n2 = 60 * t2[1] + (+t2[2] || 0);
        return 0 === n2 ? 0 : "+" === t2[0] ? -n2 : n2;
      }(e2);
    }], h = function(e2) {
      var t2 = o[e2];
      return t2 && (t2.indexOf ? t2 : t2.s.concat(t2.f));
    }, u = function(e2, t2) {
      var n2, r2 = o.meridiem;
      if (r2) {
        for (var i2 = 1; i2 <= 24; i2 += 1) if (e2.indexOf(r2(i2, 0, t2)) > -1) {
          n2 = i2 > 12;
          break;
        }
      } else n2 = e2 === (t2 ? "pm" : "PM");
      return n2;
    }, d = { A: [i, function(e2) {
      this.afternoon = u(e2, false);
    }], a: [i, function(e2) {
      this.afternoon = u(e2, true);
    }], S: [/\d/, function(e2) {
      this.milliseconds = 100 * +e2;
    }], SS: [n, function(e2) {
      this.milliseconds = 10 * +e2;
    }], SSS: [/\d{3}/, function(e2) {
      this.milliseconds = +e2;
    }], s: [r, a("seconds")], ss: [r, a("seconds")], m: [r, a("minutes")], mm: [r, a("minutes")], H: [r, a("hours")], h: [r, a("hours")], HH: [r, a("hours")], hh: [r, a("hours")], D: [r, a("day")], DD: [n, a("day")], Do: [i, function(e2) {
      var t2 = o.ordinal, n2 = e2.match(/\d+/);
      if (this.day = n2[0], t2) for (var r2 = 1; r2 <= 31; r2 += 1) t2(r2).replace(/\[|\]/g, "") === e2 && (this.day = r2);
    }], M: [r, a("month")], MM: [n, a("month")], MMM: [i, function(e2) {
      var t2 = h("months"), n2 = (h("monthsShort") || t2.map(function(e3) {
        return e3.slice(0, 3);
      })).indexOf(e2) + 1;
      if (n2 < 1) throw new Error();
      this.month = n2 % 12 || n2;
    }], MMMM: [i, function(e2) {
      var t2 = h("months").indexOf(e2) + 1;
      if (t2 < 1) throw new Error();
      this.month = t2 % 12 || t2;
    }], Y: [/[+-]?\d+/, a("year")], YY: [n, function(e2) {
      this.year = s(e2);
    }], YYYY: [/\d{4}/, a("year")], Z: f, ZZ: f };
    function c(n2) {
      var r2, i2;
      r2 = n2, i2 = o && o.formats;
      for (var s2 = (n2 = r2.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t2, n3, r3) {
        var o2 = r3 && r3.toUpperCase();
        return n3 || i2[r3] || e[r3] || i2[o2].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e2, t3, n4) {
          return t3 || n4.slice(1);
        });
      })).match(t), a2 = s2.length, f2 = 0; f2 < a2; f2 += 1) {
        var h2 = s2[f2], u2 = d[h2], c2 = u2 && u2[0], l = u2 && u2[1];
        s2[f2] = l ? { regex: c2, parser: l } : h2.replace(/^\[|\]$/g, "");
      }
      return function(e2) {
        for (var t2 = {}, n3 = 0, r3 = 0; n3 < a2; n3 += 1) {
          var i3 = s2[n3];
          if ("string" == typeof i3) r3 += i3.length;
          else {
            var o2 = i3.regex, f3 = i3.parser, h3 = e2.slice(r3), u3 = o2.exec(h3)[0];
            f3.call(t2, u3), e2 = e2.replace(u3, "");
          }
        }
        return function(e3) {
          var t3 = e3.afternoon;
          if (void 0 !== t3) {
            var n4 = e3.hours;
            t3 ? n4 < 12 && (e3.hours += 12) : 12 === n4 && (e3.hours = 0), delete e3.afternoon;
          }
        }(t2), t2;
      };
    }
    return function(e2, t2, n2) {
      n2.p.customParseFormat = true, e2 && e2.parseTwoDigitYear && (s = e2.parseTwoDigitYear);
      var r2 = t2.prototype, i2 = r2.parse;
      r2.parse = function(e3) {
        var t3 = e3.date, r3 = e3.utc, s2 = e3.args;
        this.$u = r3;
        var a2 = s2[1];
        if ("string" == typeof a2) {
          var f2 = true === s2[2], h2 = true === s2[3], u2 = f2 || h2, d2 = s2[2];
          h2 && (d2 = s2[2]), o = this.$locale(), !f2 && d2 && (o = n2.Ls[d2]), this.$d = function(e4, t4, n3) {
            try {
              if (["x", "X"].indexOf(t4) > -1) return new Date(("X" === t4 ? 1e3 : 1) * e4);
              var r4 = c(t4)(e4), i3 = r4.year, o2 = r4.month, s3 = r4.day, a3 = r4.hours, f3 = r4.minutes, h3 = r4.seconds, u3 = r4.milliseconds, d3 = r4.zone, l2 = /* @__PURE__ */ new Date(), m2 = s3 || (i3 || o2 ? 1 : l2.getDate()), M2 = i3 || l2.getFullYear(), Y = 0;
              i3 && !o2 || (Y = o2 > 0 ? o2 - 1 : l2.getMonth());
              var p = a3 || 0, v = f3 || 0, D = h3 || 0, g = u3 || 0;
              return d3 ? new Date(Date.UTC(M2, Y, m2, p, v, D, g + 60 * d3.offset * 1e3)) : n3 ? new Date(Date.UTC(M2, Y, m2, p, v, D, g)) : new Date(M2, Y, m2, p, v, D, g);
            } catch (e5) {
              return /* @__PURE__ */ new Date("");
            }
          }(t3, a2, r3), this.init(), d2 && true !== d2 && (this.$L = this.locale(d2).$L), u2 && t3 != this.format(a2) && (this.$d = /* @__PURE__ */ new Date("")), o = {};
        } else if (a2 instanceof Array) for (var l = a2.length, m = 1; m <= l; m += 1) {
          s2[1] = a2[m - 1];
          var M = n2.apply(this, s2);
          if (M.isValid()) {
            this.$d = M.$d, this.$L = M.$L, this.init();
            break;
          }
          m === l && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else i2.call(this, e3);
      };
    };
  });
})(customParseFormat$1);
var customParseFormatExports = customParseFormat$1.exports;
const customParseFormat = /* @__PURE__ */ getDefaultExportFromCjs(customParseFormatExports);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
function InvitationListModal() {
  const classPrefix = "invitation-list-modal";
  const [isLoading, setLoading] = useState(false);
  const [invitationList, setInvitationList] = useState([]);
  const { invitedList } = useSupabase();
  const { isInvitationListModalShow, setIsInvitationListModalShow, setToastInfo } = useChatroom();
  const onCloseModal = () => {
    setIsInvitationListModalShow(false);
  };
  const getInvitationList = () => __awaiter(this, void 0, void 0, function* () {
    try {
      setLoading(true);
      const list = yield invitedList();
      setInvitationList(list);
    } catch (error) {
      setToastInfo({ type: "error", message: error.message });
    } finally {
      setLoading(false);
    }
  });
  useEffect(() => {
    if (isInvitationListModalShow) {
      getInvitationList();
    }
  }, [isInvitationListModalShow]);
  return jsxRuntimeExports.jsx(CommonModal, { onRequestClose: onCloseModal, style: {
    overlay: {
      zIndex: 100
    },
    content: {
      zIndex: 1e3,
      height: "100%",
      width: "100%",
      backgroundColor: "#101A25",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      border: "none",
      borderRadius: "0",
      padding: "0"
    }
  }, isOpen: isInvitationListModalShow, ariaHideApp: false, children: jsxRuntimeExports.jsxs("section", { className: `${classPrefix}`, children: [jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-header`, children: [jsxRuntimeExports.jsx("button", { onClick: onCloseModal, children: jsxRuntimeExports.jsx(CloseSVG, {}) }), jsxRuntimeExports.jsx("div", { className: "title", children: "Invitation List" }), jsxRuntimeExports.jsx("span", { style: { width: "56px" } })] }), jsxRuntimeExports.jsx("div", { className: `${classPrefix}-content`, children: isLoading ? jsxRuntimeExports.jsx("div", { className: "loading-wrapper", children: jsxRuntimeExports.jsx(Loading, {}) }) : invitationList.length === 0 ? jsxRuntimeExports.jsxs("div", { className: `${classPrefix}-content-empty`, children: [jsxRuntimeExports.jsx("img", { src: "/images/ill.png", alt: "" }), jsxRuntimeExports.jsx("p", { style: { width: "100%", textAlign: "center" }, children: "No Invitation Information" })] }) : jsxRuntimeExports.jsx("ul", { className: `${classPrefix}-list`, children: invitationList.map((invitation) => jsxRuntimeExports.jsxs("li", { children: [jsxRuntimeExports.jsxs("div", { className: "top", children: [jsxRuntimeExports.jsx("img", { src: invitation.avatar, alt: "avatar" }), jsxRuntimeExports.jsxs("div", { children: [jsxRuntimeExports.jsx("span", { children: invitation.name }), jsxRuntimeExports.jsx("p", { children: "Request to add friend" })] })] }), jsxRuntimeExports.jsxs("div", { className: "bottom", children: [jsxRuntimeExports.jsx("div", { className: "date", children: dayjs(invitation.invite_time).format("MMMM Do") }), jsxRuntimeExports.jsx(InvitationButtonGroup, Object.assign({}, invitation, { getInvitationList }))] })] }, invitation.id)) }) })] }) });
}
const InvitationButtonGroup = ({ invite_status, is_invitee, id, getInvitationList }) => {
  const { handleInviterAccepted, handleInviterRejected, getChatroom } = useSupabase();
  const { setToastInfo } = useChatroom();
  const [isLoading, setIsLoading] = useState(false);
  const onHandleAccept = (id2) => {
    return () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        setIsLoading(true);
        yield handleInviterAccepted(id2);
        yield getInvitationList();
        setToastInfo({ type: "success", message: "The invitation was accepted successfully." });
        getChatroom();
      } catch (error) {
        setToastInfo({ type: "error", message: error.message });
      } finally {
        setIsLoading(false);
      }
    });
  };
  const onHandleReject = (id2) => {
    return () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        setIsLoading(true);
        yield handleInviterRejected(id2);
        yield getInvitationList();
        setToastInfo({ type: "success", message: "The invitation was refused successfully." });
      } catch (error) {
        setToastInfo({ type: "error", message: error.message });
      } finally {
        setIsLoading(false);
      }
    });
  };
  if (invite_status === "pending") {
    if (is_invitee) {
      return jsxRuntimeExports.jsx("div", { className: "btnGroup", children: jsxRuntimeExports.jsx("button", { className: "btn pending", disabled: true, children: "Pending" }) });
    } else {
      return jsxRuntimeExports.jsxs("div", { className: "btnGroup", children: [jsxRuntimeExports.jsx("button", { disabled: isLoading, className: "btn accept", onClick: onHandleAccept(id), children: "Accept" }), jsxRuntimeExports.jsx("button", { disabled: isLoading, className: "btn reject", onClick: onHandleReject(id), children: "Reject" })] });
    }
  } else {
    return jsxRuntimeExports.jsxs("div", { className: "btnGroup", children: [invite_status === "accepted" && jsxRuntimeExports.jsx("button", { disabled: true, className: `btn ${invite_status}`, children: "Accepted" }), invite_status === "rejected" && jsxRuntimeExports.jsx("button", { disabled: true, className: `btn ${invite_status}`, children: "Rejected" })] });
  }
};
const ProviderListen = ({ children, supabase_public_chat = null, supabase_public = null, app_name = null, app_version = null, isChatWithAi }) => {
  useListenerMessage({ app_name, app_version, supabase_public, supabase_public_chat, isChatWithAi });
  return jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(CompareFilesModal, {}), jsxRuntimeExports.jsx(FilesModal, {}), jsxRuntimeExports.jsx(RemoveFile, {}), jsxRuntimeExports.jsx(FillFormModal, {}), jsxRuntimeExports.jsx(EditBotModal, {}), jsxRuntimeExports.jsx(RemoveChatroom, {}), jsxRuntimeExports.jsx(NewFriendsModal, { appName: app_name, appVersion: app_version }), jsxRuntimeExports.jsx(InvitationListModal, {}), children] });
};
const ChatroomProvider = ({ children, supabase_public_chat = null, supabase_public = null, app_name = null, app_version = null, isChatWithAi }) => {
  if (!app_name)
    throw new Error("Please fill your app name.");
  if (!supabase_public)
    throw new Error("Please fill in the instance of supabase whose schema is public.");
  if (!supabase_public_chat)
    throw new Error("Please fill in the instance of supabase whose schema is public_chat.");
  const [editFileState, setEditFileState] = useState({
    isRemoveOpen: false,
    fileName: ""
  });
  const [toastInfo, setToastInfo] = useState({ message: "" });
  const [isEditChatroomModalShow, setIsEditChatroomModalShow] = useState(false);
  const [editChatroomState, setEditChatroomState] = useState("Create");
  const [files, setFiles] = useState([]);
  const [botMessage, setBotMessage] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [messages, setMessages] = useState([]);
  const [currentChatroom, setCurrentChatroom] = useState(null);
  const [chatroomList, setChatroomList] = useState([]);
  const [user, setUser] = useState(null);
  const [isCompareFilesModalShow, setIsCompareFilesModalShow] = useState(false);
  const [isFilesModalShow, setIsFilesModalShow] = useState(false);
  const [isRemoveFileModalShow, setIsRemoveFileModalShow] = useState(false);
  const [isAddBotModalShow, setIsAddBotModalShow] = useState(false);
  const [bidContactDocumentName, setBidContactDocumentName] = useState("");
  const [specificationDocumentName, setSpecificationDocumentName] = useState("");
  const [selectFileType, setSelectFileType] = useState(null);
  const [isOpenNewFriendModal, setIsOpenNewFriendModal] = useState(false);
  const [removeFileName, setRemoveFileName] = useState(null);
  const [isFillFormModalShow, setIsFillFormModalShow] = useState(false);
  const [isRemoveChatroomModalShow, setIsRemoveChatroomModalShow] = useState(false);
  const [isInvitationListModalShow, setIsInvitationListModalShow] = useState(false);
  const contextValue = useMemo(() => {
    return {
      app_name,
      supabase_public,
      supabase_public_chat,
      isChatWithAi,
      chatroomList,
      currentChatroom,
      setChatroomList,
      setCurrentChatroom,
      messages,
      setMessages,
      botMessage,
      setBotMessage,
      isGenerating,
      setIsGenerating,
      user,
      setUser,
      isCompareFilesModalShow,
      setIsCompareFilesModalShow,
      isFilesModalShow,
      setIsFilesModalShow,
      bidContactDocumentName,
      setBidContactDocumentName,
      specificationDocumentName,
      setSpecificationDocumentName,
      files,
      setFiles,
      toastInfo,
      setToastInfo,
      editFileState,
      setEditFileState,
      selectFileType,
      setSelectFileType,
      isRemoveFileModalShow,
      setIsRemoveFileModalShow,
      removeFileName,
      setRemoveFileName,
      isFillFormModalShow,
      setIsFillFormModalShow,
      isAddBotModalShow,
      setIsAddBotModalShow,
      isEditChatroomModalShow,
      setIsEditChatroomModalShow,
      editChatroomState,
      setEditChatroomState,
      isRemoveChatroomModalShow,
      setIsRemoveChatroomModalShow,
      isOpenNewFriendModal,
      setIsOpenNewFriendModal,
      isInvitationListModalShow,
      setIsInvitationListModalShow
    };
  }, [app_name, supabase_public, supabase_public_chat, isChatWithAi, chatroomList, currentChatroom, messages, botMessage, isGenerating, user, isCompareFilesModalShow, isFilesModalShow, bidContactDocumentName, specificationDocumentName, files, toastInfo, editFileState, selectFileType, isRemoveFileModalShow, removeFileName, isFillFormModalShow, isAddBotModalShow, isEditChatroomModalShow, editChatroomState, isRemoveChatroomModalShow, isOpenNewFriendModal, isInvitationListModalShow]);
  return jsxRuntimeExports.jsx(ChatContext.Provider, { value: contextValue, children: jsxRuntimeExports.jsx(ProviderListen, { app_name, app_version, supabase_public, supabase_public_chat, isChatWithAi, children }) });
};
export {
  ChatroomProvider as default
};
